import type { Icon } from 'ngxi'

export const dashiconsAdminAppearance: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14.48 11.06L7.41 3.99l1.5-1.5c.5-.56 2.3-.47 3.51.32c1.21.8 1.43 1.28 2.91 2.1c1.18.64 2.45 1.26 4.45.85zm-.71.71L6.7 4.7L4.93 6.47a.996.996 0 0 0 0 1.41l1.06 1.06c.39.39.39 1.03 0 1.42c-.6.6-1.43 1.11-2.21 1.69c-.35.26-.7.53-1.01.84C1.43 14.23.4 16.08 1.4 17.07c.99 1 2.84-.03 4.18-1.36c.31-.31.58-.66.85-1.02c.57-.78 1.08-1.61 1.69-2.21a.996.996 0 0 1 1.41 0l1.06 1.06c.39.39 1.02.39 1.41 0z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAdminCollapse: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 2.16A7.84 7.84 0 1 1 2.16 10c0-4.33 3.55-7.84 7.84-7.84m2 11.72V6.12L6.18 9.97z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAdminComments: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 2h9c1.1 0 2 .9 2 2v7c0 1.1-.9 2-2 2h-2l-5 5v-5H5c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAdminCustomizer: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18.33 3.57s.27-.8-.31-1.36c-.53-.52-1.22-.24-1.22-.24c-.61.3-5.76 3.47-7.67 5.57c-.86.96-2.06 3.79-1.09 4.82c.92.98 3.96-.17 4.79-1c2.06-2.06 5.21-7.17 5.5-7.79M1.4 17.65c2.37-1.56 1.46-3.41 3.23-4.64c.93-.65 2.22-.62 3.08.29c.63.67.8 2.57-.16 3.46c-1.57 1.45-4 1.55-6.15.89\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAdminGeneric: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 12h-2.18c-.17.7-.44 1.35-.81 1.93l1.54 1.54l-2.1 2.1l-1.54-1.54c-.58.36-1.23.63-1.91.79V19H8v-2.18c-.68-.16-1.33-.43-1.91-.79l-1.54 1.54l-2.12-2.12l1.54-1.54c-.36-.58-.63-1.23-.79-1.91H1V9.03h2.17c.16-.7.44-1.35.8-1.94L2.43 5.55l2.1-2.1l1.54 1.54c.58-.37 1.24-.64 1.93-.81V2h3v2.18c.68.16 1.33.43 1.91.79l1.54-1.54l2.12 2.12l-1.54 1.54c.36.59.64 1.24.8 1.94H18zm-8.5 1.5c1.66 0 3-1.34 3-3s-1.34-3-3-3s-3 1.34-3 3s1.34 3 3 3\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAdminHome: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m16 8.5l1.53 1.53l-1.06 1.06L10 4.62l-6.47 6.47l-1.06-1.06L10 2.5l4 4v-2h2zm-6-2.46l6 5.99V18H4v-5.97zM12 17v-5H8v5z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAdminLinks: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17.74 2.76a4.32 4.32 0 0 1 0 6.1l-1.53 1.52c-1.12 1.12-2.7 1.47-4.14 1.09l2.62-2.61l.76-.77l.76-.76c.84-.84.84-2.2 0-3.04a2.13 2.13 0 0 0-3.04 0l-.77.76l-3.38 3.38c-.37-1.44-.02-3.02 1.1-4.14l1.52-1.53a4.32 4.32 0 0 1 6.1 0M8.59 13.43l5.34-5.34c.42-.42.42-1.1 0-1.52c-.44-.43-1.13-.39-1.53 0l-5.33 5.34c-.42.42-.42 1.1 0 1.52c.44.43 1.13.39 1.52 0m-.76 2.29l4.14-4.15c.38 1.44.03 3.02-1.09 4.14l-1.52 1.53a4.32 4.32 0 0 1-6.1 0a4.32 4.32 0 0 1 0-6.1l1.53-1.52c1.12-1.12 2.7-1.47 4.14-1.1l-4.14 4.15c-.85.84-.85 2.2 0 3.05c.84.84 2.2.84 3.04 0\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAdminMedia: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13 11V4c0-.55-.45-1-1-1h-1.67L9 1H5L3.67 3H2c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h10c.55 0 1-.45 1-1M7 4.5a2.5 2.5 0 0 1 0 5a2.5 2.5 0 0 1 0-5M14 6h5v10.5a2.5 2.5 0 0 1-5 0a2.5 2.5 0 0 1 3-2.45V9h-3zm-4 8.05V13h2v3.5a2.5 2.5 0 0 1-5 0a2.5 2.5 0 0 1 3-2.45\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAdminMultisite: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14.27 6.87L10 3.14L5.73 6.87L5 6.14l5-4.38l5 4.38zM14 8.42l-4.05 3.43L6 8.38v-.74l4-3.5l4 3.5zM11 9.7V8H9v1.7zm-1.73 4.03L5 10L.73 13.73L0 13l5-4.38L10 13zm10 0L15 10l-4.27 3.73L10 13l5-4.38L20 13zM5 11l4 3.5V18H1v-3.5zm10 0l4 3.5V18h-8v-3.5zm-9 6v-2H4v2zm10 0v-2h-2v2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAdminNetwork: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16.95 2.58a4.985 4.985 0 0 1 0 7.07c-1.51 1.51-3.75 1.84-5.59 1.01l-1.87 3.31l-2.99.31L5 18H2l-1-2l7.95-7.69c-.92-1.87-.62-4.18.93-5.73a4.985 4.985 0 0 1 7.07 0m-2.51 3.79c.74 0 1.33-.6 1.33-1.34a1.33 1.33 0 1 0-2.66 0c0 .74.6 1.34 1.33 1.34\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAdminPage: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 15V2h10v13zm-1 1h8v2H3V5h2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAdminPlugins: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.11 4.36L9.87 7.6L8 5.73l3.24-3.24c.35-.34 1.05-.2 1.56.32c.52.51.66 1.21.31 1.55m-8 1.77l.91-1.12l9.01 9.01l-1.19.84c-.71.71-2.63 1.16-3.82 1.16H6.14L4.9 17.26c-.59.59-1.54.59-2.12 0a1.49 1.49 0 0 1 0-2.12l1.24-1.24v-3.88c0-1.13.4-3.19 1.09-3.89m7.26 3.97l3.24-3.24c.34-.35 1.04-.21 1.55.31c.52.51.66 1.21.31 1.55l-3.24 3.25z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAdminPost: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m10.44 3.02l1.82-1.82l6.36 6.35l-1.83 1.82a2.73 2.73 0 0 0-3.41.36l-.75.75c-.92.93-1.04 2.35-.35 3.41l-1.83 1.82l-2.41-2.41l-2.8 2.79c-.42.42-3.38 2.71-3.8 2.29s1.86-3.39 2.28-3.81l2.79-2.79L4.1 9.36l1.83-1.82c1.05.69 2.48.57 3.4-.36l.75-.75c.93-.92 1.05-2.35.36-3.41\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAdminSettings: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 16V4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h13c.55 0 1-.45 1-1M8 11h1c.55 0 1 .45 1 1s-.45 1-1 1H8v1.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5V13H6c-.55 0-1-.45-1-1s.45-1 1-1h1V5.5c0-.28.22-.5.5-.5s.5.22.5.5zm5-2h-1c-.55 0-1-.45-1-1s.45-1 1-1h1V5.5c0-.28.22-.5.5-.5s.5.22.5.5V7h1c.55 0 1 .45 1 1s-.45 1-1 1h-1v5.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAdminSite: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0m3.46 11.95c0 1.47-.8 3.3-4.06 4.7c.3-4.17-2.52-3.69-3.2-5A3.25 3.25 0 0 1 7 9.1a8.5 8.5 0 0 1-4.18-2c.05.47.279.904.64 1.21a4.2 4.2 0 0 1-1.94-1.5a7.94 7.94 0 0 1 7.25-5.63c-.84 1.38-1.5 4.13 0 5.57C7.23 7 6.26 5 5.41 5.79c-1.13 1.06.33 2.51 3.42 3.08c3.29.59 3.66 1.58 3.63 3.08m1.34-4c-.32-1.11.62-2.23 1.69-3.14a7.27 7.27 0 0 1 .84 6.68c-.77-1.89-2.17-2.32-2.53-3.57z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAdminSiteAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0m7.5 6.48a3.38 3.38 0 0 1-1.75 2.05a5.64 5.64 0 0 0-3.27-3.75a2 2 0 0 1 .79-1.09c-.43-.28-1-.42-1.34.07c-.53.69 0 1.61.21 2v.14A3.07 3.07 0 0 1 9.9 4.46a5.2 5.2 0 0 0-2.76.69a3.44 3.44 0 0 1 .16-1.68a2.21 2.21 0 0 0 1.92-.8c.46-.52-.13-1.18-.59-1.58h.36a7.86 7.86 0 0 1 3.89 1a5.61 5.61 0 0 1 2.27 4.26c.24 0 .7-.55.91-.92q.258.51.44 1.05M9 16.84c-2.05-2.08.25-3.75-1-5.24c-.92-.85-2.29-.26-3.11-1.23a4.08 4.08 0 0 1 1.43-3.93c.52-.44 4-1 5.42.22a5.22 5.22 0 0 1 1.67 2.74a2.35 2.35 0 0 0 1.32-.29c.41 2.98-3.15 6.74-5.73 7.73M5.15 2.09a1.84 1.84 0 0 1 2.16.66c-.42.38-.94.63-1.5.72A3 3 0 0 1 6 2.61z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAdminSiteAlt2: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0m2.92 12.34c0 .35.14.63.36.66s.47-.22.58-.6l.2.08a1.72 1.72 0 0 1 .84 2a1.58 1.58 0 0 1-1.45 1.24c-.49-1.21-2.11.06-3.56-.22a1.92 1.92 0 0 1-1.33-1.19c1.19-.11 2.85-1.73 4.36-1.97M8 11.27a1.84 1.84 0 0 0 1.82-1.59a1.39 1.39 0 0 1-.07 1.83A1.17 1.17 0 0 1 8 11.27m3-.76c.41.39 3-.06 3.52 1.09c-.95-.2-2.95.61-3.47-1.08zM9.73 5.45v.27c-.65-.77-1.33-1.07-1.61-.57s1 1.11.76 1.88S7.61 7.59 7 8.64s-.49 2.42 1.24 3.67A3 3 0 0 1 5.7 10.2c-.4-1.2-.09-2.26-.78-2.46C4 7.46 3 8.71 3 9.8c-1.26-1.26.05-2.86-1.2-4.18a7.89 7.89 0 0 1 9.64-4.13a5.34 5.34 0 0 0-1.71 3.96\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAdminSiteAlt3: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0M1.11 9.68h2.51c.04.91.167 1.814.38 2.7H1.84a7.9 7.9 0 0 1-.73-2.7m8.57-5.4V1.19a4.13 4.13 0 0 1 2.22 2q.308.521.54 1.08zm3.22 1.35c.232.883.37 1.788.41 2.7H9.68v-2.7zM8.32 1.19v3.09H5.56A8.5 8.5 0 0 1 6.1 3.2a4.13 4.13 0 0 1 2.22-2.01m0 4.44v2.7H4.7c.04-.912.178-1.817.41-2.7zm-4.7 2.69H1.11a7.9 7.9 0 0 1 .73-2.7H4a14 14 0 0 0-.38 2.7M4.7 9.68h3.62v2.7H5.11a13 13 0 0 1-.41-2.7m3.63 4v3.09a4.13 4.13 0 0 1-2.22-2a8.5 8.5 0 0 1-.54-1.08zm1.35 3.09v-3.04h2.76a8.5 8.5 0 0 1-.54 1.08a4.13 4.13 0 0 1-2.22 2zm0-4.44v-2.7h3.62a13 13 0 0 1-.41 2.7zm4.71-2.7h2.51a7.9 7.9 0 0 1-.73 2.7H14c.21-.87.337-1.757.38-2.65zm0-1.35A14 14 0 0 0 14 5.63h2.16c.403.85.65 1.764.73 2.7zm1-4H13.6a8.9 8.9 0 0 0-1.39-2.52a8 8 0 0 1 3.14 2.52zm-9.6-2.52A8.9 8.9 0 0 0 4.4 4.28H2.65a8 8 0 0 1 3.14-2.52m-3.15 12H4.4a8.9 8.9 0 0 0 1.39 2.52a8 8 0 0 1-3.14-2.55zm9.56 2.52a8.9 8.9 0 0 0 1.39-2.52h1.76a8 8 0 0 1-3.14 2.48z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAdminTools: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16.68 9.77a4.54 4.54 0 0 1-4.95.99l-5.41 6.52c-.99.99-2.59.99-3.58 0s-.99-2.59 0-3.57l6.52-5.42c-.68-1.65-.35-3.61.99-4.95c1.28-1.28 3.12-1.62 4.72-1.06l-2.89 2.89l2.82 2.82l2.86-2.87c.53 1.58.18 3.39-1.08 4.65M3.81 16.21c.4.39 1.04.39 1.43 0c.4-.4.4-1.04 0-1.43c-.39-.4-1.03-.4-1.43 0a1.02 1.02 0 0 0 0 1.43\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAdminUsers: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 9.25c-2.27 0-2.73-3.44-2.73-3.44C7 4.02 7.82 2 9.97 2c2.16 0 2.98 2.02 2.71 3.81c0 0-.41 3.44-2.68 3.44m0 2.57L12.72 10c2.39 0 4.52 2.33 4.52 4.53v2.49s-3.65 1.13-7.24 1.13c-3.65 0-7.24-1.13-7.24-1.13v-2.49c0-2.25 1.94-4.48 4.47-4.48z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAirplane: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17.6 2.4c-.8-.8-2.1-.1-2.7.5l-3.5 3.8l-2.4-1l.6-.6c.2-.2.2-.5 0-.7c-.1-.2-.4-.1-.6 0l-.9.9l-1.8-.8l.5-.5c.2-.2.2-.5 0-.6c-.2-.2-.5-.2-.7 0l-.8.8l-.5-.2c-.8-.4-1.7-.3-2.3.4l5.8 5.8L6 12.6l-3.5-.2l-.5.7l3.1 1.8L6.9 18l.7-.5l-.2-3.5l2.5-2.3l5.8 5.8c.6-.6.8-1.6.4-2.3l-.2-.5l.8-.8c.2-.2.2-.5 0-.7s-.5-.2-.7 0l-.5.5l-.8-1.9l.9-.9c.2-.2.2-.5 0-.7s-.5-.2-.6 0l-.6.6l-1-2.4L17.2 5c.6-.5 1.2-1.9.4-2.6\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAlbum: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 18h10v-.26c1.52.4 3.17.35 4.76-.24c4.14-1.52 6.27-6.12 4.75-10.26c-1.43-3.89-5.58-6-9.51-4.98V2H0zM9 3v14H1V3zm5.45 8.22a2.746 2.746 0 0 1-3.67 1.23c-.31-.15-.57-.35-.78-.59V8.13c.8-.86 2.11-1.13 3.22-.58c1.35.68 1.9 2.32 1.23 3.67m-2.75-.82c.22.16.53.12.7-.1c.16-.22.12-.53-.1-.7s-.53-.12-.7.1c-.16.21-.12.53.1.7m3.01 3.67c-1.17.78-2.56.99-3.83.69c-.27-.06-.44-.34-.37-.61s.34-.43.62-.36l.17.04c.96.17 1.98-.01 2.86-.59c.47-.32.86-.72 1.14-1.18c.15-.23.45-.3.69-.16c.23.15.3.46.16.69c-.36.57-.84 1.08-1.44 1.48m1.05 1.57a6.76 6.76 0 0 1-4.84 1.06a.505.505 0 1 1 .2-.99l.22.04c1.31.15 2.68-.14 3.87-.94c.71-.47 1.27-1.07 1.7-1.74c.14-.24.45-.31.68-.16c.24.14.31.45.16.69c-.49.79-1.16 1.49-1.99 2.04\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAlignCenter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 5h14V3H3zm12 8V7H5v6zM3 17h14v-2H3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAlignFullWidth: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 13V3H3v10zM5 17h10v-2H5z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAlignLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 5h14V3H3zm9 8V7H3v6zm2-4h3V7h-3zm0 4h3v-2h-3zM3 17h14v-2H3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAlignNone: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 5h14V3H3zm10 8V7H3v6zM3 17h14v-2H3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAlignPullLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 16V4H3v12zm2-7h6V7h-6zm0 4h6v-2h-6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAlignPullRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 16V4h-6v12zM9 7H3v2h6zm0 4H3v2h6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAlignRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 5h14V3H3zm0 4h3V7H3zm14 4V7H8v6zM3 13h3v-2H3zm0 4h14v-2H3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAlignWide: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 5h10V3H5zm12 8V7H3v6zM5 17h10v-2H5z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAmazon: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M16.2 14.9c-1.9.8-4 1.2-6.1 1.2c-2.8 0-5.5-.7-7.9-2.1c-.2-.1-.3.1-.2.2c2.2 2 5 3 7.9 3c2.3 0 4.6-.7 6.5-2c.4-.1.1-.5-.2-.3m1.8-1c-.9-.4-2-.3-2.8.3c-.2.1-.1.3 0 .2c.6-.1 1.8-.2 2 .1s-.2 1.5-.5 2c-.1.2.1.2.2.1c.8-.7 1.2-1.7 1.1-2.7m-9-1.3c1.1.1 2.2-.4 2.9-1.3c.3.4.6.8 1 1.2c.1.1.3.1.4 0c.3-.3 1-.9 1.3-1.2c.1-.1.1-.3 0-.5c-.4-.4-.6-1-.7-1.6V6.5c0-1.1.1-2.2-.8-3c-.7-.6-1.7-.9-2.6-.9c-1.6.1-3.5.7-3.8 2.7q0 .3.3.3l1.7.2c.2 0 .3-.2.3-.3c.1-.7.7-1.1 1.4-1c.4 0 .7.2 1 .5c.2.4.3.8.2 1.3v.2q-1.65 0-3.3.6c-1.2.4-2 1.5-1.9 2.8v.4c0 1.3 1.2 2.4 2.6 2.3m2.5-4.8v.4c.1.6 0 1.3-.3 1.8c-.2.5-.7.8-1.2.8c-.7 0-1.1-.5-1.1-1.3c0-1.4 1.3-1.7 2.6-1.7\" clip-rule=\"evenodd\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAnalytics: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 18V2H2v16zM16 5H4V4h12zM7 7v3h3c0 1.66-1.34 3-3 3s-3-1.34-3-3s1.34-3 3-3m1 2V7c1.1 0 2 .9 2 2zm8-1h-4V7h4zm0 3h-4V9h4zm0 2h-4v-1h4zm0 3H4v-1h12z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsArchive: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19 4v2H1V4zM2 7h16v10H2zm11 3V9H7v1z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsArrowDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m15 8l-4.03 6L7 8z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsArrowDownAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 2h2v12l4-4l2 1l-7 7l-7-7l2-1l4 4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsArrowDownAlt2: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m5 6l5 5l5-5l2 1l-7 7l-7-7z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsArrowLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13 14L7 9.97L13 6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsArrowLeftAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 9v2H6l4 4l-1 2l-7-7l7-7l1 2l-4 4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsArrowLeftAlt2: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m14 5l-5 5l5 5l-1 2l-7-7l7-7z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsArrowRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m8 6l6 4.03L8 14z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsArrowRightAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 11V9h12l-4-4l1-2l7 7l-7 7l-1-2l4-4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsArrowRightAlt2: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m6 15l5-5l-5-5l1-2l7 7l-7 7z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsArrowUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m11 7l-4 6h8z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsArrowUpAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 18H9V6l-4 4l-2-1l7-7l7 7l-2 1l-4-4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsArrowUpAlt2: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m15 14l-5-5l-5 5l-2-1l7-7l7 7z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsArrowUpDuplicate: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m7 13l4.03-6L15 13z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsArt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8.55 3.06c1.01.34-1.95 2.01-.1 3.13c1.04.63 3.31-2.22 4.45-2.86c.97-.54 2.67-.65 3.53 1.23c1.09 2.38.14 8.57-3.79 11.06c-3.97 2.5-8.97 1.23-10.7-2.66c-2.01-4.53 3.12-11.09 6.61-9.9m1.21 6.45c.73 1.64 4.7-.5 3.79-2.8c-.59-1.49-4.48 1.25-3.79 2.8\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsAwards: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4.46 5.16L5 7.46l-.54 2.29l2.01 1.24L7.7 13l2.3-.54l2.3.54l1.23-2.01l2.01-1.24L15 7.46l.54-2.3l-2-1.24l-1.24-2.01l-2.3.55l-2.29-.54l-1.25 2zm5.55 6.34a3.999 3.999 0 1 1 0-8c2.2 0 3.99 1.79 3.99 3.99c0 2.22-1.79 4.01-3.99 4.01m-.02-1C8.33 10.5 7 9.16 7 7.5c0-1.65 1.33-3 2.99-3S13 5.85 13 7.5c0 1.66-1.35 3-3.01 3m3.84 1.1l-1.28 2.24l-2.08-.47L13 19.2l1.4-2.2h2.5zm-7.7.07l1.25 2.25l2.13-.51L7 19.2L5.6 17H3.1z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBackup: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.65 2.88c3.93 2.01 5.48 6.84 3.47 10.77s-6.83 5.48-10.77 3.47a7.94 7.94 0 0 1-3.86-4.4l1.64-1.03a6.13 6.13 0 0 0 3.08 3.76c3.01 1.54 6.69.35 8.23-2.66A6.114 6.114 0 1 0 4.56 7.21l1.88.97l-4.95 3.08l-.39-5.82l1.78.91C4.9 2.4 9.75.89 13.65 2.88m-4.36 7.83A1 1 0 0 1 9 10c0-.07.03-.12.04-.19h-.01L10 5l.97 4.81L14 13l-4.5-2.12l.02-.02c-.08-.04-.16-.09-.23-.15\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBank: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 2L3 6v1h14V6zM5 8l-.2 7h2.5L7 8zm4 0l-.2 7h2.5L11 8zm4 0l-.2 7h2.5L15 8zM3 18h14v-2H3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBeer: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.8 9.3c-.8-.1-1.5-.4-2-1s-.9-1.3-1-2c-.4-.1-.7-.3-1-.6c-.4-.5-.6-1-.7-1.5l-.9.9l-.8-.7c-.6-.7-1.7-.7-2.4 0L2.5 6.9c-.7.7-.7 1.8 0 2.5l.7.8l-.6.6c-.7.7-.7 1.8 0 2.5l4.3 4.3c.7.7 1.8.7 2.4 0l6.4-6.5c-.5-.1-1-.3-1.4-.7c-.1-.4-.3-.8-.5-1.1M3.6 7.6l2-2c.3-.3.8-.3 1 0l.5.5l-2.9 3.1l-.6-.6c-.2-.3-.2-.7 0-1m.6 4.7c-.3-.3-.3-.7 0-.9L8.5 7c.3-.3.7-.3.9 0c.3.3.3.7 0 .9l-4.3 4.3c-.3.3-.7.3-.9.1M6 14.1c-.3-.3-.3-.7 0-.9l4.3-4.3c.3-.3.7-.3.9 0c.3.3.3.7 0 .9l-4.3 4.3c-.2.3-.6.3-.9 0m7.1-2.5L8.8 16c-.3.3-.7.3-.9 0c-.3-.3-.3-.7 0-.9l4.3-4.3c.3-.3.7-.3.9 0c.2.1.2.6 0 .8m4.4-4.4c-.2-.2-.5-.4-.7-.4c.4-1 .2-2.2-.6-2.9c-.8-.8-1.9-1-2.9-.6c-.1-.3-.3-.6-.5-.8c-.7-.7-1.8-.7-2.4 0c-.7.7-.7 1.8 0 2.5c.3.3.8.5 1.2.5c-.1.8.2 1.6.8 2.2s1.4.8 2.2.8c0 .5.2.9.5 1.2c.7.7 1.8.7 2.4 0c.7-.7.7-1.8 0-2.5\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBell: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 18c1.1 0 2-.9 2-2H8c0 1.1.9 2 2 2m4-8.2V7.5c0-1.8-1.2-3.4-3-3.9c.1-.2.1-.4.2-.5c-.1-.6-.6-1.1-1.2-1.1s-1.1.5-1.1 1.1c0 .2.1.4.2.5c-1.8.4-3 2-3 3.9v2.2c-.1 1.2-.9 2.3-2 2.8V15h12v-2.5c-1.2-.4-2-1.5-2.1-2.7\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBlockDefault: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15 6V4h-3v2H8V4H5v2H4c-.6 0-1 .4-1 1v8h14V7c0-.6-.4-1-1-1z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBook: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16 3h2v16H5c-1.66 0-3-1.34-3-3V4c0-1.66 1.34-3 3-3h9v14H5c-.55 0-1 .45-1 1s.45 1 1 1h11z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBookAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 17h13v2H5c-1.66 0-3-1.34-3-3V4c0-1.66 1.34-3 3-3h13v14H5c-.55 0-1 .45-1 1s.45 1 1 1m2-3.5v-11c0-.28-.22-.5-.5-.5s-.5.22-.5.5v11c0 .28.22.5.5.5s.5-.22.5-.5\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBuddiconsActivity: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 1v7h2V6c0-1.52 1.45-3 3-3v.86c.55-.52 1.26-.86 2-.86v3h1c1.1 0 2 .9 2 2s-.9 2-2 2h-1v6c0 .55-.45 1-1 1s-1-.45-1-1v-2.18c-.31.11-.65.18-1 .18v2c0 .55-.45 1-1 1s-1-.45-1-1v-2H8v2c0 .55-.45 1-1 1s-1-.45-1-1v-2c-.35 0-.69-.07-1-.18V16c0 .55-.45 1-1 1s-1-.45-1-1v-4H2v-1c0-1.66 1.34-3 3-3h2V1zm5 7c.55 0 1-.45 1-1s-.45-1-1-1s-1 .45-1 1s.45 1 1 1\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBuddiconsBbpressLogo: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4.5 6.2C3.7 7.3 3.3 8.6 3.3 10c0 1 .2 1.9.6 2.8l1-4.6c.3-1.7.4-2-.4-2m4 6.4c.3-1.3 0-2.3-1.1-2.3c-.8 0-1.6.6-1.8 1.5l-.3 1.7c-.3 1 .3 1.5 1 1.5c1.2 0 1.9-1.1 2.2-2.4M10 2c-4.4 0-8 3.6-8 8s3.6 8 8 8s8-3.6 8-8s-3.6-8-8-8m0 15.5c-2.1 0-4-.8-5.3-2.2c-.3-.4-.7-.8-1-1.2c-.7-1.2-1.2-2.6-1.2-4.1c0-4.1 3.4-7.5 7.5-7.5s7.5 3.4 7.5 7.5s-3.4 7.5-7.5 7.5m3.8-4.9c.3-1.3 0-2.3-1.1-2.3c-.8 0-1.6.6-1.8 1.5l-.4 1.7c-.2 1.1.4 1.6 1.1 1.6c1.1-.1 1.9-1.2 2.2-2.5M10 3.3c-2 0-3.9.9-5.1 2.3c.6-.1 1.4-.2 1.8-.3c.2 0 .2.1.2.2c0 .2-1 4.8-1 4.8c.5-.3 1.2-.7 1.8-.7c.9 0 1.5.4 1.9.9l.5-2.4c.4-1.6.4-1.9-.4-1.9c-.4 0-.4-.5 0-.6c.6-.1 1.8-.2 2.3-.3c.2 0 .2.1.2.2l-1 4.8c.5-.4 1.2-.7 1.9-.7c1.7 0 2.5 1.3 2.1 3c-.3 1.7-2 3-3.8 3c-1.3 0-2.1-.7-2.3-1.4c-.7.8-1.7 1.3-2.8 1.4c1.1.7 2.4 1.1 3.7 1.1a6.7 6.7 0 0 0 0-13.4\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBuddiconsBuddypressLogo: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 0c5.52 0 10 4.48 10 10s-4.48 10-10 10S0 15.52 0 10S4.48 0 10 0m0 .5C4.75.5.5 4.75.5 10s4.25 9.5 9.5 9.5s9.5-4.25 9.5-9.5S15.25.5 10 .5m0 1c4.7 0 8.5 3.8 8.5 8.5s-3.8 8.5-8.5 8.5s-8.5-3.8-8.5-8.5S5.3 1.5 10 1.5m1.8 1.71c-.57 0-1.1.17-1.55.45a3.55 3.55 0 0 1 2.73 3.45c0 .69-.21 1.33-.55 1.87a2.92 2.92 0 0 0 2.29-2.85c0-1.61-1.31-2.92-2.92-2.92m-2.38 1a2.926 2.926 0 1 0 .011 5.851A2.926 2.926 0 0 0 9.42 4.21m4.25 5.01l-.51.59c2.34.69 2.45 3.61 2.45 3.61h1.28c0-4.71-3.22-4.2-3.22-4.2m-2.1.8l-2.12 2.09l-2.12-2.09C3.12 10.24 3.89 15 3.89 15h11.08c.47-4.98-3.4-4.98-3.4-4.98\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBuddiconsCommunity: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 3c0-.67-.47-1.43-1-2c-.5.5-1 1.38-1 2c0 .48.45 1 1 1s1-.47 1-1m4 0c0-.67-.47-1.43-1-2c-.5.5-1 1.38-1 2c0 .48.45 1 1 1s1-.47 1-1M9 9V5.5c0-.55-.45-1-1-1c-.57 0-1 .49-1 1V9c0 .55.45 1 1 1c.57 0 1-.49 1-1m4 0V5.5c0-.55-.45-1-1-1c-.57 0-1 .49-1 1V9c0 .55.45 1 1 1c.57 0 1-.49 1-1m4 1c0-1.48-1.41-2.77-3.5-3.46V9c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5V6.01c-.17 0-.33-.01-.5-.01s-.33.01-.5.01V9c0 .83-.67 1.5-1.5 1.5S6.5 9.83 6.5 9V6.54C4.41 7.23 3 8.52 3 10c0 1.41.95 2.65 3.21 3.37c1.11.35 2.39 1.12 3.79 1.12s2.69-.78 3.79-1.13C16.04 12.65 17 11.41 17 10m-7 5.43c1.43 0 2.74-.79 3.88-1.11c1.9-.53 2.49-1.34 3.12-2.32v3c0 2.21-3.13 4-7 4s-7-1.79-7-4v-3c.64.99 1.32 1.8 3.15 2.33c1.13.33 2.44 1.1 3.85 1.1\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBuddiconsForums: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.5 7h-7C5.67 7 5 6.33 5 5.5S5.67 4 6.5 4h1.59A1.6 1.6 0 0 1 8 3.5C8 2.67 8.67 2 9.5 2h1c.83 0 1.5.67 1.5 1.5c0 .18-.04.34-.09.5h1.59c.83 0 1.5.67 1.5 1.5S14.33 7 13.5 7M4 8h12c.55 0 1 .45 1 1s-.45 1-1 1H4c-.55 0-1-.45-1-1s.45-1 1-1m1 3h10c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1m2 3h6c.55 0 1 .45 1 1s-.45 1-1 1h-1.09c.05.16.09.32.09.5c0 .83-.67 1.5-1.5 1.5h-1c-.83 0-1.5-.67-1.5-1.5c0-.18.04-.34.09-.5H7c-.55 0-1-.45-1-1s.45-1 1-1\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBuddiconsFriends: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8.75 5.77C8.75 4.39 7 2 7 2S5.25 4.39 5.25 5.77S5.9 7.5 7 7.5s1.75-.35 1.75-1.73m6 0C14.75 4.39 13 2 13 2s-1.75 2.39-1.75 3.77S11.9 7.5 13 7.5s1.75-.35 1.75-1.73M9 17V9c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h2c.55 0 1-.45 1-1m6 0V9c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h2c.55 0 1-.45 1-1m-9-6l2-1v2l-2 1zm6 0l2-1v2l-2 1zm-6 3l2-1v2l-2 1zm6 0l2-1v2l-2 1z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBuddiconsGroups: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15.45 6.25c1.83.94 1.98 3.18.7 4.98c-.8 1.12-2.33 1.88-3.46 1.78L10.05 18H9l-2.65-4.99c-1.13.16-2.73-.63-3.55-1.79c-1.28-1.8-1.13-4.04.71-4.97c.48-.24.96-.33 1.43-.31c-.01.4.01.8.07 1.21c.26 1.69 1.41 3.53 2.86 4.37c-.19.55-.49.99-.88 1.25L9 16.58v-5.66C7.64 10.55 6.26 8.76 6 7c-.4-2.65 1-5 3.5-5s3.9 2.35 3.5 5c-.26 1.76-1.64 3.55-3 3.92v5.77l2.07-3.84c-.44-.23-.77-.71-.99-1.3c1.48-.83 2.65-2.69 2.91-4.4c.06-.41.08-.82.07-1.22c.46-.01.92.08 1.39.32\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBuddiconsPm: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 2c3 0 8 5 8 5v11H2V7s5-5 8-5m7 14.72l-3.73-2.92L17 11l-.43-.37l-2.26 1.3l.24-4.31l-8.77-.52l-.46 4.54l-1.99-.95L3 11l3.73 2.8l-3.44 2.85l.4.43L10 13l6.53 4.15z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBuddiconsReplies: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17.54 10.29a3.01 3.01 0 0 1 0 4.25a3.01 3.01 0 0 1-4.25 0l-.34-.52c0 3.66-2 4.38-2.95 4.98c-.82-.6-2.95-1.28-2.95-4.98l-.34.52a3.01 3.01 0 0 1-4.25 0a3.01 3.01 0 0 1 0-4.25s1.02-.67 2.1-1.3A6.9 6.9 0 0 1 3.2 4.88c0-.34.03-.67.08-1A6.96 6.96 0 0 0 5.8 8.3c.67-.35 1.85-.83 2.37-.92H8c-1.1 0-2-.9-2-2s.9-2 2-2v-.5c0-.28.22-.5.5-.5s.5.22.5.5v.5h2v-.5c0-.28.22-.5.5-.5s.5.22.5.5v.5c1.1 0 2 .9 2 2s-.9 2-2 2h-.17c.51.09 1.78.61 2.38.92a6.96 6.96 0 0 0 2.52-4.42c.05.33.08.66.08 1c0 1.54-.51 2.96-1.36 4.11c1.08.63 2.09 1.3 2.09 1.3M8.5 6.38c.5 0 1-.45 1-1s-.45-1-1-1s-1 .45-1 1s.45 1 1 1m3-2c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m-2.3 5.73c-.12.11-.19.26-.19.43a.5.5 0 0 0 .49.46h1a.5.5 0 0 0 .49-.46c0-.15-.07-.29-.19-.43a.5.5 0 0 0-.3-.11h-1c-.12 0-.22.05-.3.11M12 12.5c0-.12-.06-.28-.19-.38a.5.5 0 0 0-.31-.12h-3c-.12 0-.22.05-.31.12c-.11.1-.19.25-.19.38c0 .28.22.5.5.5h3c.28 0 .5-.22.5-.5M8.5 15h3c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-3c-.28 0-.5.22-.5.5s.22.5.5.5m1 2h1c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5s.22.5.5.5\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBuddiconsTopics: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.44 1.66c-.59-.58-1.54-.58-2.12 0L2.66 7.32c-.58.58-.58 1.53 0 2.12c.6.6 1.56.56 2.12 0l5.66-5.66a1.5 1.5 0 0 0 0-2.12m2.83 2.83a1.49 1.49 0 0 0-2.12 0l-5.66 5.66a1.49 1.49 0 0 0 0 2.12c.6.6 1.56.55 2.12 0l5.66-5.66c.58-.58.58-1.53 0-2.12m1.06 6.72l4.18 4.18c.59.58.59 1.53 0 2.12s-1.54.59-2.12 0l-4.18-4.18l-1.77 1.77c-.59.58-1.54.58-2.12 0c-.59-.59-.59-1.54 0-2.13l5.66-5.65a1.49 1.49 0 0 1 2.12 0c.58.58.58 1.53 0 2.12zM5 15c0-1.59-1.66-4-1.66-4S2 13.78 2 15s.6 2 1.34 2h.32C4.4 17 5 16.59 5 15\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBuddiconsTracking: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.98 6.78L15.5 15c-1 2-3.5 3-5.5 3s-4.5-1-5.5-3L9 6.82c-.75-1.23-2.28-1.98-4.29-2.03l2.46-2.92c1.68 1.19 2.46 2.32 2.97 3.31c.56-.87 1.2-1.68 2.7-2.12l1.83 2.86c-1.42-.34-2.64.08-3.69.86M8.17 10.4l-.93 1.69c.49.11 1 .16 1.54.16c1.35 0 2.58-.36 3.55-.95l-1.01-1.82c-.87.53-1.96.86-3.15.92m.86 5.38c1.99 0 3.73-.74 4.74-1.86l-.98-1.76c-1 1.12-2.74 1.87-4.74 1.87c-.62 0-1.21-.08-1.76-.21l-.63 1.15c.94.5 2.1.81 3.37.81\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBuilding: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 20h14V0H3zM7 3H5V1h2zm4 0H9V1h2zm4 0h-2V1h2zM7 6H5V4h2zm4 0H9V4h2zm4 0h-2V4h2zM7 9H5V7h2zm4 0H9V7h2zm4 0h-2V7h2zm-8 3H5v-2h2zm4 0H9v-2h2zm4 0h-2v-2h2zm-4 7H5v-6h6zm4-4h-2v-2h2zm0 3h-2v-2h2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBusinessman: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 16.9v-2.5c0-.7-.1-1.4-.5-2.1s-.9-1.3-1.6-1.7c-.7-.5-2.2-.6-2.9-.6l-1.6 1.7l.6 1.3v3l-1 1.1L9 16v-3l.7-1.3L8 10c-.8 0-2.3.1-3 .6c-.7.4-1.1 1-1.5 1.7S3 13.6 3 14.4v2.5S5.6 18 10 18s7-1.1 7-1.1M10 2.1c-1.9 0-3 1.8-2.7 3.8S8.6 9.3 10 9.3s2.4-1.4 2.7-3.4c.3-2.1-.8-3.8-2.7-3.8\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBusinessperson: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.2 10L11 13l-1-1.4L9 13l-2.2-3C3 11 3 13 3 16.9c0 0 3 1.1 6.4 1.1h1.2c3.4-.1 6.4-1.1 6.4-1.1c0-3.9 0-5.9-3.8-6.9m-3.2.7L8.4 10l1.6 1.6l1.6-1.6zm0-8.6c-1.9 0-3 1.8-2.7 3.8S8.6 9.3 10 9.3s2.4-1.4 2.7-3.4c.3-2.1-.8-3.8-2.7-3.8\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsBusinesswoman: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16 11c-.9-.8-2.2-.9-3.4-1l1 2.1l-3.6 3.7l-3.6-3.6l1-2.2c-1.2 0-2.5.2-3.4 1c-.8.7-1 1.9-1 3.1v2.8s3.4 1.2 7 1.1c3.6.1 7-1.1 7-1.1v-2.8c0-1.1-.2-2.3-1-3.1M6.6 9.3c.8 0 2-.4 2.2-.7c-.8-1-1.5-2-.8-3.9c0 0 1.1 1.2 4.3 1.5c0 1-.5 1.7-1.1 2.4c.2.3 1.4.7 2.2.7s1.4-.2 1.4-.5s-1.3-1.3-1.6-2.2s-.1-1.9-.5-3.1C12.1 2.1 10.7 2 10 2s-2.1.1-2.7 1.5c-.4 1.2-.2 2.2-.5 3.1S5.2 8.5 5.2 8.8s.6.5 1.4.5\"/><path fill=\"currentColor\" d=\"m10 11l-2.3-1l2.3 5.8l2.3-5.8z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsButton: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 5H3c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m1 7c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h14c.6 0 1 .4 1 1z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsCalculator: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15 2H5c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h10c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1M6.5 16.8c-.7 0-1.2-.6-1.2-1.2s.6-1.2 1.2-1.2s1.2.6 1.2 1.2s-.5 1.2-1.2 1.2m0-3.6c-.7 0-1.2-.6-1.2-1.2s.6-1.2 1.2-1.2s1.2.6 1.2 1.2s-.5 1.2-1.2 1.2m0-3.4c-.7 0-1.2-.6-1.2-1.2s.6-1.2 1.2-1.2s1.2.6 1.2 1.2s-.5 1.2-1.2 1.2m3.5 7c-.7 0-1.2-.6-1.2-1.2s.6-1.2 1.2-1.2s1.2.6 1.2 1.2s-.5 1.2-1.2 1.2m0-3.6c-.7 0-1.2-.6-1.2-1.2s.6-1.2 1.2-1.2s1.2.6 1.2 1.2s-.5 1.2-1.2 1.2m0-3.4c-.7 0-1.2-.6-1.2-1.2s.5-1.4 1.2-1.4s1.2.6 1.2 1.2s-.5 1.4-1.2 1.4m4.8 5.7c0 .7-.6 1.2-1.2 1.2s-1.2-.6-1.2-1.2V12c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2zm-1.3-5.7c-.7 0-1.2-.6-1.2-1.2s.6-1.2 1.2-1.2s1.2.6 1.2 1.2s-.5 1.2-1.2 1.2M15 6.4H5V3h10z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsCalendar: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15 4h3v14H2V4h3V3c0-.83.67-1.5 1.5-1.5S8 2.17 8 3v1h4V3c0-.83.67-1.5 1.5-1.5S15 2.17 15 3zM6 3v2.5c0 .28.22.5.5.5s.5-.22.5-.5V3c0-.28-.22-.5-.5-.5S6 2.72 6 3m7 0v2.5c0 .28.22.5.5.5s.5-.22.5-.5V3c0-.28-.22-.5-.5-.5s-.5.22-.5.5m4 14V8H3v9zM7 16V9H5v7zm4 0V9H9v7zm4 0V9h-2v7z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsCalendarAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15 4h3v15H2V4h3V3c0-.41.15-.76.44-1.06c.29-.29.65-.44 1.06-.44s.77.15 1.06.44c.29.3.44.65.44 1.06v1h4V3c0-.41.15-.76.44-1.06c.29-.29.65-.44 1.06-.44s.77.15 1.06.44c.29.3.44.65.44 1.06zM6 3v2.5a.49.49 0 0 0 .5.5a.49.49 0 0 0 .5-.5V3c0-.14-.05-.26-.15-.35c-.09-.1-.21-.15-.35-.15s-.26.05-.35.15c-.1.09-.15.21-.15.35m7 0v2.5c0 .14.05.26.14.36c.1.09.22.14.36.14s.26-.05.36-.14c.09-.1.14-.22.14-.36V3a.49.49 0 0 0-.5-.5a.49.49 0 0 0-.5.5m4 15V8H3v10zM7 9v2H5V9zm2 0h2v2H9zm4 2V9h2v2zm-6 1v2H5v-2zm2 0h2v2H9zm4 2v-2h2v2zm-6 1v2H5v-2zm4 2H9v-2h2zm4 0h-2v-2h2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsCamera: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 5V3H3v2zm12 10V4H9L7 6H2v9zm-7-8c1.66 0 3 1.34 3 3s-1.34 3-3 3s-3-1.34-3-3s1.34-3 3-3\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsCameraAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15 4h2.94c.59 0 1.06.47 1.06 1.06v11.81c0 .59-.47 1.13-1.06 1.13H2.06C1.47 18 1 17.46 1 16.87V5.06C1 4.47 1.47 4 2.06 4H5l3-2h4zm-5 11c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsCar: Icon = {
  "body": "<circle cx=\"14\" cy=\"13.5\" r=\"1.5\" fill=\"currentColor\"/><path fill=\"currentColor\" d=\"M16.1 9h-1.6c-.6-2.7-3.2-4.5-5.9-3.9C6.6 5.5 5 7 4.6 9h-.7c-1 0-1.9.9-1.9 1.9v1.3c0 .7.6 1.3 1.3 1.3h.3c0-1.3 1.1-2.4 2.4-2.4s2.4 1.1 2.4 2.4h3.2c0-1.3 1.1-2.4 2.4-2.4s2.4 1.1 2.4 2.4h.3c.7 0 1.3-.6 1.3-1.3V11c0-1.1-.9-2-1.9-2M6.2 9c.5-1.9 2.5-2.9 4.3-2.4c1.1.3 2 1.2 2.4 2.4zM6 12c-.8 0-1.5.7-1.5 1.5S5.2 15 6 15s1.5-.7 1.5-1.5S6.8 12 6 12\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsCarrot: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 18.43c1.51 1.36 11.64-4.67 13.14-7.21c.72-1.22-.13-3.01-1.52-4.44C15.2 5.73 16.59 9 17.91 8.31c.6-.32.99-1.31.7-1.92c-.52-1.08-2.25-1.08-3.42-1.21c.83-.2 2.82-1.05 2.86-2.25c.04-.92-1.13-1.97-2.05-1.86c-1.21.14-1.65 1.88-2.06 3c-.05-.71-.2-2.27-.98-2.95c-1.04-.91-2.29-.05-2.32 1.05c-.04 1.33 2.82 2.07 1.92 3.67C11.04 4.67 9.25 4.03 8.1 4.7c-.49.31-1.05.91-1.63 1.69c.89.94 2.12 2.07 3.09 2.72c.2.14.26.42.11.62c-.14.21-.42.26-.62.12c-.99-.67-2.2-1.78-3.1-2.71c-.45.67-.91 1.43-1.34 2.23c.85.86 1.93 1.83 2.79 2.41c.2.14.25.42.11.62c-.14.21-.42.26-.63.12c-.85-.58-1.86-1.48-2.71-2.32C2.4 13.69 1.1 17.63 2 18.43\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsCart: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 13h9c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1V4H2c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1v2h13l-4 7H6zm-.5 3c.83 0 1.5.67 1.5 1.5S6.33 19 5.5 19S4 18.33 4 17.5S4.67 16 5.5 16m9 0c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsCategory: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 7h13v10H2V4h7l2 2H4v9h1z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsChartArea: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m18 18l.01-12.28c.59-.35.99-.99.99-1.72c0-1.1-.9-2-2-2s-2 .9-2 2c0 .8.47 1.48 1.14 1.8l-4.13 6.58c-.33-.24-.73-.38-1.16-.38c-.84 0-1.55.51-1.85 1.24l-2.14-1.53c.09-.22.14-.46.14-.71c0-1.11-.89-2-2-2a2 2 0 0 0-2 2a2 2 0 0 0 .98 1.71L1 18zM17 3c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1M5 10c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m5.85 3c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsChartBar: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 18V2h-4v16zm-6 0V7H8v11zm-6 0v-8H2v8z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsChartLine: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 3.5c0 .62-.38 1.16-.92 1.38v13.11H1.99l4.22-6.73A1.5 1.5 0 0 1 6 10.5C6 9.67 6.67 9 7.5 9S9 9.67 9 10.5c0 .13-.02.25-.05.37l1.44.63c.27-.3.67-.5 1.11-.5c.18 0 .35.04.51.09l3.58-6.41c-.36-.27-.59-.7-.59-1.18c0-.83.67-1.5 1.5-1.5c.19 0 .36.04.53.1l.05-.09v.11c.54.22.92.76.92 1.38m-1.92 13.49V5.85l-3.29 5.89c.13.23.21.48.21.76c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5l.01-.07l-1.63-.72c-.25.18-.55.29-.88.29c-.18 0-.35-.04-.51-.1l-3.2 5.09z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsChartPie: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 10V3c3.87 0 7 3.13 7 7zM9 4v7h7c0 3.87-3.13 7-7 7s-7-3.13-7-7s3.13-7 7-7\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsClipboard: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m11.9.39l1.4 1.4c1.61.19 3.5-.74 4.61.37s.18 3 .37 4.61l1.4 1.4c.39.39.39 1.02 0 1.41l-9.19 9.2c-.4.39-1.03.39-1.42 0L1.29 11c-.39-.39-.39-1.02 0-1.42l9.2-9.19a.996.996 0 0 1 1.41 0m.58 2.25l-.58.58l4.95 4.95l.58-.58c-.19-.6-.2-1.22-.15-1.82c.02-.31.05-.62.09-.92c.12-1 .18-1.63-.17-1.98s-.98-.29-1.98-.17c-.3.04-.61.07-.92.09c-.6.05-1.22.04-1.82-.15m4.02.93c.39.39.39 1.03 0 1.42s-1.03.39-1.42 0s-.39-1.03 0-1.42s1.03-.39 1.42 0m-6.72.36l-.71.7L15.44 11l.7-.71zM8.36 5.34l-.7.71l6.36 6.36l.71-.7zM6.95 6.76l-.71.7l6.37 6.37l.7-.71zM5.54 8.17l-.71.71l6.36 6.36l.71-.71zM4.12 9.58l-.71.71l6.37 6.37l.71-.71z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsClock: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 2c4.42 0 8 3.58 8 8s-3.58 8-8 8s-8-3.58-8-8s3.58-8 8-8m0 14c3.31 0 6-2.69 6-6s-2.69-6-6-6s-6 2.69-6 6s2.69 6 6 6m-.71-5.29c.07.05.14.1.23.15l-.02.02L14 13l-3.03-3.19L10 5l-.97 4.81h.01c0 .02-.01.05-.02.09S9 9.97 9 10c0 .28.1.52.29.71\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsCloud: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14.9 9c0-.3.1-.6.1-1c0-2.2-1.8-4-4-4c-1.6 0-2.9.9-3.6 2.2c-.2-.1-.6-.2-.9-.2C5.1 6 4 7.1 4 8.5c0 .2 0 .4.1.5c-1.8.3-3.1 1.7-3.1 3.5C1 14.4 2.6 16 4.5 16h10c1.9 0 3.5-1.6 3.5-3.5c0-1.8-1.3-3.3-3.1-3.5\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsCloudSaved: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14.8 9c.1-.3.2-.6.2-1c0-2.2-1.8-4-4-4c-1.5 0-2.9.9-3.5 2.2c-.3-.1-.7-.2-1-.2C5.1 6 4 7.1 4 8.5c0 .2 0 .4.1.5c-1.8.3-3.1 1.7-3.1 3.5C1 14.4 2.6 16 4.5 16h10c1.9 0 3.5-1.6 3.5-3.5c0-1.8-1.4-3.3-3.2-3.5m-6.3 5.9l-3.2-3.2l1.4-1.4l1.8 1.8l3.8-3.8l1.4 1.4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsCloudUpload: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14.8 9c.1-.3.2-.6.2-1c0-2.2-1.8-4-4-4c-1.5 0-2.9.9-3.5 2.2c-.3-.1-.7-.2-1-.2C5.1 6 4 7.1 4 8.5c0 .2 0 .4.1.5c-1.8.3-3.1 1.7-3.1 3.5C1 14.4 2.6 16 4.5 16H8v-3H5l4.5-4.5L14 13h-3v3h3.5c1.9 0 3.5-1.6 3.5-3.5c0-1.8-1.4-3.3-3.2-3.5\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsCodeStandards: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.1 9.5V8.4c0-.5-.2-.7-.7-.8c.6-.1.8-.3.8-.9V5.6c0-.4.1-.5.7-.5h.3v-.5h-.6c-.9 0-1.3.2-1.3 1c0 .5.1.8.1 1.2c0 .2-.2.5-.9.5v.6c.7 0 .9.3.9.5c0 .4-.1.7-.1 1.2c0 .8.4 1 1.3 1h.5V10h-.3c-.5 0-.7-.1-.7-.5m10.4 4.4c-.8-.8-1.7-1.4-2.6-2c-.1-.1-1.1-1.1-1.5-1.4c2.4-4-1.1-9.2-5.7-8.5c-4.4.7-6.3 6.2-3.2 9.4c1.7 1.9 4.6 2.3 6.9 1.1c.6.6 1.1 1.1 1.6 1.7c.7.9 1.2 1.8 2.1 2.5c.6.5 1.4 1.2 2.3 1.3c1.1.1 1.7-.6 1.7-1.6c-.1-.9-1-1.9-1.6-2.5m-8.9-2.3c-2.2 0-4-1.8-4-4s1.8-4 4-4s4 1.8 4 4s-1.8 4-4 4m2.1-4.8c0-.4.1-.7.1-1.2c0-.8-.4-1-1.3-1H8v.5h.3c.5 0 .7.1.7.5v1.1c0 .5.2.7.7.8c-.6.2-.8.4-.8.9v1.1c.1.4-.1.5-.6.5H8v.6h.5c.9 0 1.3-.2 1.3-1c0-.5-.1-.8-.1-1.2c0-.2.2-.5.9-.5v-.6c-.7 0-.9-.3-.9-.5\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsCoffee: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 15c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2zm2-3.8v.8c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2V4H5.6C3.6 4 2 5.4 2 7.6c0 2.3 1.6 3.6 3.6 3.6zM3.9 7.6c0-1 .7-1.8 1.7-1.8H6v3.6h-.4c-1 0-1.7-.7-1.7-1.8\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsColorPicker: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17.8 2.2c-1-1-2.6-1-3.6 0L12.4 4l-.7-.7c-.4-.4-1-.4-1.4 0l-.8.7c-.4.4-.4 1 0 1.4l5 5c.4.4 1 .4 1.4 0l.7-.7c.4-.4.4-1 0-1.4l-.6-.7l1.8-1.8c1-1 1-2.6 0-3.6M4.4 12c-2.2 2.2-.9 3.2-2.9 5.8l.7.7c2.6-2 3.6-.7 5.8-2.9l5.1-5.1l-3.6-3.6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsColumns: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 15h6V5H3zm8 0h6V5h-6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsControlsBack: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m2 10l10-6v3.6L18 4v12l-6-3.6V16z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsControlsForward: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 10L8 16v-3.6L2 16V4l6 3.6V4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsControlsPause: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 16V4h3v12zm7-12h3v12h-3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsControlsPlay: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m5 4l10 6l-10 6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsControlsRepeat: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 7v3l-2 1.5V5h11V3l4 3.01L14 9V7zm10 6v-3l2-1.5V15H6v2l-4-3.01L6 11v2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsControlsSkipback: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m11.98 7.63l6-3.6v12l-6-3.6v3.6l-8-4.8v4.8h-2v-12h2v4.8l8-4.8z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsControlsSkipforward: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 12.4L2 16V4l6 3.6V4l8 4.8V4h2v12h-2v-4.8L8 16z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsControlsVolumeoff: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 7h4l5-4v14l-5-4H2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsControlsVolumeon: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 7h4l5-4v14l-5-4H2zm12.69-2.46C14.82 4.59 18 5.92 18 10s-3.18 5.41-3.31 5.46a.49.49 0 0 1-.65-.27c-.11-.26.02-.55.27-.65c.11-.05 2.69-1.15 2.69-4.54c0-3.41-2.66-4.53-2.69-4.54a.493.493 0 0 1-.27-.65c.1-.25.39-.38.65-.27M16 10c0 2.57-2.23 3.43-2.32 3.47q-.09.03-.18.03c-.2 0-.39-.12-.47-.32c-.1-.26.04-.55.29-.65c.07-.02 1.68-.67 1.68-2.53s-1.61-2.51-1.68-2.53a.52.52 0 0 1-.29-.65c.1-.25.39-.39.65-.29c.09.04 2.32.9 2.32 3.47\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsCoverImage: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2.2 1h15.5c.7 0 1.3.6 1.3 1.2v11.5c0 .7-.6 1.2-1.2 1.2H2.2c-.6.1-1.2-.5-1.2-1.1V2.2C1 1.6 1.6 1 2.2 1M17 13V3H3v10zm-4-4s0-5 3-5v7c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1V7c2 0 3 4 3 4s1-4 3-4s3 2 3 2m-9 8h12v2H4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsDashboard: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.76 16h12.48A7.998 7.998 0 0 0 10 3a7.998 7.998 0 0 0-6.24 13M10 4c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1M6 6c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m8 0c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m-5.37 5.55L12 7v6c0 1.1-.9 2-2 2s-2-.9-2-2c0-.57.24-1.08.63-1.45M4 10c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m12 0c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m-5 3c0-.55-.45-1-1-1s-1 .45-1 1s.45 1 1 1s1-.45 1-1\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsDatabase: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 6c3.9 0 7-.9 7-2s-3.1-2-7-2s-7 .9-7 2s3.1 2 7 2m0 9c-3.9 0-7-.9-7-2v3c0 1.1 3.1 2 7 2s7-.9 7-2v-3c0 1.1-3.1 2-7 2m0-4c-3.9 0-7-.9-7-2v3c0 1.1 3.1 2 7 2s7-.9 7-2V9c0 1.1-3.1 2-7 2m0-4c-3.9 0-7-.9-7-2v3c0 1.1 3.1 2 7 2s7-.9 7-2V5c0 1.1-3.1 2-7 2\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsDatabaseAdd: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14 10c2.2 0 4-1.8 4-4s-1.8-4-4-4s-4 1.8-4 4s1.8 4 4 4m-1-5V3h2v2h2v2h-2v2h-2V7h-2V5zM9 6c0-1.6.8-3 2-4h-1c-3.9 0-7 .9-7 2c0 1 2.6 1.8 6 2m1 9c-3.9 0-7-.9-7-2v3c0 1.1 3.1 2 7 2s7-.9 7-2v-3c0 1.1-3.1 2-7 2m2.8-4.2c-.9.1-1.9.2-2.8.2c-3.9 0-7-.9-7-2v3c0 1.1 3.1 2 7 2s7-.9 7-2v-2c-.9.7-1.9 1-3 1c-.4 0-.8-.1-1.2-.2M10 10h1c-1-.7-1.7-1.8-1.9-3C5.7 6.9 3 6 3 5v3c0 1.1 3.1 2 7 2\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsDatabaseExport: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 6c0-1.6.8-3 2-4h-1c-3.9 0-7 .9-7 2c0 1 2.6 1.8 6 2m1 9c-3.9 0-7-.9-7-2v3c0 1.1 3.1 2 7 2s7-.9 7-2v-3c0 1.1-3.1 2-7 2m2.8-4.2c-.9.1-1.9.2-2.8.2c-3.9 0-7-.9-7-2v3c0 1.1 3.1 2 7 2s7-.9 7-2v-2c-.9.7-1.9 1-3 1c-.4 0-.8-.1-1.2-.2M10 10h1c-1-.7-1.7-1.8-1.9-3C5.7 6.9 3 6 3 5v3c0 1.1 3.1 2 7 2m4 0c2.2 0 4-1.8 4-4s-1.8-4-4-4s-4 1.8-4 4s1.8 4 4 4m0-7l3 3h-2v3h-2V6h-2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsDatabaseImport: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 6c0-1.6.8-3 2-4h-1c-3.9 0-7 .9-7 2c0 1 2.6 1.8 6 2m3.8 4.8c-.9.1-1.9.2-2.8.2c-3.9 0-7-.9-7-2v3c0 1.1 3.1 2 7 2s7-.9 7-2v-2c-.9.7-1.9 1-3 1c-.4 0-.8-.1-1.2-.2M10 15c-3.9 0-7-.9-7-2v3c0 1.1 3.1 2 7 2s7-.9 7-2v-3c0 1.1-3.1 2-7 2m0-5h1c-1-.7-1.7-1.8-1.9-3C5.7 6.9 3 6 3 5v3c0 1.1 3.1 2 7 2m4 0c2.2 0 4-1.8 4-4s-1.8-4-4-4s-4 1.8-4 4s1.8 4 4 4m-1-4V3h2v3h2l-3 3l-3-3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsDatabaseRemove: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14 10c2.2 0 4-1.8 4-4s-1.8-4-4-4s-4 1.8-4 4s1.8 4 4 4m3-5v2h-6V5zM9 6c0-1.6.8-3 2-4h-1c-3.9 0-7 .9-7 2c0 1 2.6 1.8 6 2m3.8 4.8c-.9.1-1.9.2-2.8.2c-3.9 0-7-.9-7-2v3c0 1.1 3.1 2 7 2s7-.9 7-2v-2c-.9.7-1.9 1-3 1c-.4 0-.8-.1-1.2-.2M10 10h1c-1-.7-1.7-1.8-1.9-3C5.7 6.9 3 6 3 5v3c0 1.1 3.1 2 7 2m0 5c-3.9 0-7-.9-7-2v3c0 1.1 3.1 2 7 2s7-.9 7-2v-3c0 1.1-3.1 2-7 2\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsDatabaseView: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 6c0-1.6.8-3 2-4h-1c-3.9 0-7 .9-7 2c0 1 2.6 1.8 6 2m3.8 4.8c-.9.1-1.9.2-2.8.2c-3.9 0-7-.9-7-2v3c0 1.1 3.1 2 7 2s7-.9 7-2v-2c-.9.7-1.9 1-3 1c-.4 0-.8-.1-1.2-.2M10 15c-3.9 0-7-.9-7-2v3c0 1.1 3.1 2 7 2s7-.9 7-2v-3c0 1.1-3.1 2-7 2m0-5h1c-1-.7-1.7-1.8-1.9-3C5.7 6.9 3 6 3 5v3c0 1.1 3.1 2 7 2m4 0c2.2 0 4-1.8 4-4s-1.8-4-4-4s-4 1.8-4 4s1.8 4 4 4m-2.3-4.4l1.7 1.7l2.9-2.9l.7.7l-3.6 3.6L11 6.3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsDesktop: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 2h14c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1h-5v2h2c.55 0 1 .45 1 1v1H5v-1c0-.55.45-1 1-1h2v-2H3c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1m13 9V4H4v7zM5 5h9L5 9z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsDismiss: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 2c4.42 0 8 3.58 8 8s-3.58 8-8 8s-8-3.58-8-8s3.58-8 8-8m5 11l-3-3l3-3l-2-2l-3 3l-3-3l-2 2l3 3l-3 3l2 2l3-3l3 3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsDownload: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14.01 4v6h2V2H4v8h2.01V4zm-2 2v6h3l-5 6l-5-6h3V6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsDrumstick: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17.2 4.5c-.4-.7-1-1.2-1.6-1.6C13 1.3 9.7 2 8.1 4.5c-.5.8-.8 1.8-.8 2.7c0 1.5-.6 3-1.6 4.1l-.8.8c-.5.5-1.9.2-2.5 1.2c-1.1 1.9.7 2.6 1.2 3.1s1.2 2.4 3.1 1.2c.9-.6.6-1.9 1.2-2.5l.8-.8c1.1-1 2.6-1.6 4.1-1.6c.3 0 .6 0 .8-.1c-.8-1.6-.2-3.5 1.3-4.3c.9-.5 2.1-.5 3 0c.3-1.3 0-2.7-.7-3.8\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEdit: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m13.89 3.39l2.71 2.72c.46.46.42 1.24.03 1.64l-8.01 8.02l-5.56 1.16l1.16-5.58s7.6-7.63 7.99-8.03c.39-.39 1.22-.39 1.68.07m-2.73 2.79l-5.59 5.61l1.11 1.11l5.54-5.65zm-2.97 8.23l5.58-5.6l-1.07-1.08l-5.59 5.6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditLarge: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m6.4 14.1l1.3 1.3l6.9-6.9l-1.3-1.3zm6.3-7.5l-1.3-1.3l-6.9 6.9l1.4 1.4zm2.1-4.7l3.3 3.3c.6.6.5 1.5 0 2l-9.9 9.9l-6.9 1.4l1.4-6.9q9.3-9.45 9.9-9.9c.6-.4 1.6-.4 2.2.2\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditPage: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 5H2v13h10v-2H4zm13.9-1.6l-1.3-1.3c-.4-.4-1.1-.5-1.6-.1l-1 1H5v12h9V9l4-4c.4-.5.3-1.2-.1-1.6m-5.7 6l-2.5.9l.9-2.5L15 3.4L16.6 5z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorAligncenter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14 5V3H6v2zm3 4V7H3v2zm-3 4v-2H6v2zm3 4v-2H3v2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorAlignleft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 5V3H3v2zm5 4V7H3v2zm-5 4v-2H3v2zm5 4v-2H3v2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorAlignright: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 5V3H8v2zm0 4V7H3v2zm0 4v-2H8v2zm0 4v-2H3v2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorBold: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 4v13h4.54c1.37 0 2.46-.33 3.26-1c.8-.66 1.2-1.58 1.2-2.77q0-1.26-.51-2.01c-.51-.75-.9-.85-1.67-1.03v-.09c.57-.1 1.02-.4 1.36-.9s.51-1.13.51-1.91c0-1.14-.39-1.98-1.17-2.5C12.75 4.26 11.5 4 9.78 4zm2.57 5.15V6.26h1.36c.73 0 1.27.11 1.61.32c.34.22.51.58.51 1.07c0 .54-.16.92-.47 1.15s-.82.35-1.51.35zm0 2.19h1.6c1.44 0 2.16.53 2.16 1.61c0 .6-.17 1.05-.51 1.34s-.86.43-1.57.43H8.57z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorBreak: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16 4h2v9H7v3l-5-4l5-4v3h9z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorCode: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m9 6l-4 4l4 4l-1 2l-6-6l6-6zm2 8l4-4l-4-4l1-2l6 6l-6 6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorCodeDuplicate: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m9 6l-4 4l4 4l-1 2l-6-6l6-6zm2 8l4-4l-4-4l1-2l6 6l-6 6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorContract: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15.75 6.75L18 3v14l-2.25-3.75L17 12h-4v4l1.25-1.25L18 17H2l3.75-2.25L7 16v-4H3l1.25 1.25L2 17V3l2.25 3.75L3 8h4V4L5.75 5.25L2 3h16l-3.75 2.25L13 4v4h4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorCustomchar: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 5.4q1.905 0 2.91 1.08c.66.71 1 1.76 1 3.13q0 1.92-.69 3.27c-.47.89-1.27 1.52-2.22 2.12v2h6v-2h-3.69c.92-.64 1.62-1.34 2.12-2.34c.49-1.01.74-2.13.74-3.35c0-1.78-.55-3.19-1.65-4.22S11.92 3.54 10 3.54s-3.43.53-4.52 1.57q-1.65 1.56-1.65 4.2c0 1.21.24 2.31.73 3.33c.48 1.01 1.19 1.71 2.1 2.36H3v2h6v-2c-.98-.64-1.8-1.28-2.24-2.17c-.45-.89-.67-1.96-.67-3.22c0-1.37.33-2.41 1-3.13Q8.08 5.4 10 5.4\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorExpand: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 8h6v4H7zm-5 5v4h4l-1.2-1.2L7 12l-3.8 2.2M14 17h4v-4l-1.2 1.2L13 12l2.2 3.8M14 3l1.3 1.3L13 8l3.8-2.2L18 7V3M6 3H2v4l1.2-1.2L7 8L4.7 4.3\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorHelp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 10c0-3.87-3.14-7-7-7c-3.87 0-7 3.13-7 7s3.13 7 7 7c3.86 0 7-3.13 7-7m-6.3 1.48H9.14v-.43c0-.38.08-.7.24-.98s.46-.57.88-.89c.41-.29.68-.53.81-.71c.14-.18.2-.39.2-.62c0-.25-.09-.44-.28-.58c-.19-.13-.45-.19-.79-.19c-.58 0-1.25.19-2 .57l-.64-1.28c.87-.49 1.8-.74 2.77-.74c.81 0 1.45.2 1.92.58c.48.39.71.91.71 1.55c0 .43-.09.8-.29 1.11c-.19.32-.57.67-1.11 1.06c-.38.28-.61.49-.71.63q-.15.225-.15.57zm-1.47 2.74c-.18-.17-.27-.42-.27-.73c0-.33.08-.58.26-.75s.43-.25.77-.25c.32 0 .57.09.75.26s.27.42.27.74c0 .3-.09.55-.27.72q-.27.27-.75.27c-.33 0-.58-.09-.76-.26\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorIndent: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 5V3h9v2zm10-1V3h4v1zm0 3h2V5l4 3.5l-4 3.5v-2h-2zM3 8V6h9v2zm2 3V9h7v2zm-2 3v-2h9v2zm10 0v-1h4v1zm-4 3v-2h3v2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorInsertmore: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 7V3H3v4zM6 11V9H3v2zm6 0V9H8v2zm5 0V9h-3v2zm0 6v-4H3v4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorItalic: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14.78 6h-2.13l-2.8 9h2.12l-.62 2H4.6l.62-2h2.14l2.8-9H8.03l.62-2h6.75z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorJustify: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 3h16v2H2zm0 4h16v2H2zm0 4h16v2H2zm0 4h16v2H2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorKitchensink: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19 2v6H1V2zm-1 5V3H2v4zM5 4v2H3V4zm3 0v2H6V4zm3 0v2H9V4zm3 0v2h-2V4zm3 0v2h-2V4zm2 5v9H1V9zm-1 8v-7H2v7zM5 11v2H3v-2zm3 0v2H6v-2zm3 0v2H9v-2zm6 0v2h-5v-2zm-6 3v2H3v-2zm3 0v2h-2v-2zm3 0v2h-2v-2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorLtr: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13 2H5.5C3 2 1 4 1 6.5S3 11 5.5 11H6v6c0 .5.5 1 1 1s1-.5 1-1V5c0-.5.5-1 1-1s1 .5 1 1v12c0 .5.5 1 1 1s1-.5 1-1V4h1c.5 0 1-.5 1-1s-.5-1-1-1m1 4v8l5-4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorOl: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 7V3h-.69L4.02 4.03l.4.51l.46-.37c.06-.05.16-.14.3-.28l-.02.42V7zm2-2h9v1H8zm-1.23 6.95v-.7H5.05v-.04l.51-.48c.33-.31.57-.54.7-.71c.14-.17.24-.33.3-.49c.07-.16.1-.33.1-.51c0-.21-.05-.4-.16-.56c-.1-.16-.25-.28-.44-.37s-.41-.14-.65-.14q-.285 0-.51.06c-.15.03-.29.09-.42.15c-.12.07-.29.19-.48.35l.45.54q.24-.195.45-.3c.15-.07.3-.1.45-.1c.14 0 .26.03.35.11s.13.2.13.36q0 .15-.06.3c-.06.15-.1.21-.19.33c-.09.11-.29.32-.58.62l-.99 1v.58zM8 10h9v1H8zm-1.29 3.95c0-.3-.12-.54-.37-.71c-.24-.17-.58-.26-1-.26c-.52 0-.96.13-1.33.4l.4.6c.17-.11.32-.19.46-.23c.14-.05.27-.07.41-.07c.38 0 .58.15.58.46c0 .2-.07.35-.22.43s-.38.12-.7.12h-.31v.66h.31q.51 0 .75.12c.15.08.23.22.23.41c0 .22-.07.37-.2.47q-.21.15-.63.15c-.19 0-.38-.03-.57-.08s-.36-.12-.52-.2v.74c.34.15.74.22 1.18.22c.53 0 .94-.11 1.22-.33c.29-.22.43-.52.43-.92c0-.27-.09-.48-.26-.64s-.42-.26-.74-.3v-.02c.27-.06.49-.19.65-.37c.15-.18.23-.39.23-.65M8 15h9v1H8z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorOlRtl: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15 8.8c.1-.1.3-.1.4-.1s.3 0 .4.1s.2.2.2.3s0 .2-.1.3c0 .1-.1.2-.2.3l-.6.6l-1 1v.7h2.8v-.7h-1.7l.5-.5l.7-.7c.1-.1.2-.3.3-.5s.1-.3.1-.5s-.1-.4-.2-.6s-.3-.3-.4-.4c-.2-.1-.4-.2-.7-.1c-.2 0-.3 0-.5.1c-.1 0-.3.1-.4.1c-.2.1-.3.2-.5.4l.5.4c.1-.1.3-.2.4-.2m1.7 6.5c-.2-.2-.5-.3-.7-.3c.3-.1.5-.2.6-.4c.2-.2.2-.4.2-.6c0-.3-.1-.6-.4-.7c-.3-.2-.6-.3-1-.3c-.5 0-.9.1-1.3.4l.4.6c.1-.1.3-.2.5-.2c.1 0 .3-.1.4-.1c.4 0 .6.2.6.5c0 .2-.1.3-.2.4c-.2.1-.5.1-.7.1h-.3v.7h.3c.3 0 .5 0 .8.1c.2.1.2.2.2.4s-.1.4-.2.5c-.2.1-.4.2-.6.2s-.4 0-.6-.1c-.2 0-.4-.1-.5-.2v.7c.4.2.8.2 1.2.2s.9-.1 1.2-.3s.4-.6.4-.9s-.1-.5-.3-.7M15 4.2q.15 0 .3-.3V7h.8V3h-.7l-1.3 1l.4.5zM4 6h9V5H4zm0 5h9v-1H4zm0 5h9v-1H4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorOutdent: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 4V3H3v1zm10 1V3H8v2zM7 7H5V5L1 8.5L5 12v-2h2zm10 1V6H8v2zm-2 3V9H8v2zm2 3v-2H8v2zM7 14v-1H3v1zm4 3v-2H8v2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorParagraph: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15 2H7.54q-1.245 0-2.28.6q-1.05.615-1.65 1.65C3.2 4.94 3 5.7 3 6.52s.2 1.58.61 2.27c.4.69.95 1.24 1.65 1.64c.69.41 1.45.61 2.28.61h.43V17c0 .27.1.51.29.71c.2.19.44.29.71.29c.28 0 .51-.1.71-.29c.2-.2.3-.44.3-.71V5c0-.27.09-.51.29-.71c.2-.19.44-.29.71-.29s.51.1.71.29c.19.2.29.44.29.71v12c0 .27.1.51.3.71c.2.19.43.29.71.29c.27 0 .51-.1.71-.29c.19-.2.29-.44.29-.71V4H15c.27 0 .5-.1.7-.3c.2-.19.3-.43.3-.7s-.1-.51-.3-.71A.98.98 0 0 0 15 2\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorPasteText: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.38 2L15 5v1H5V5l2.64-3zM10 5c.55 0 1-.44 1-1c0-.55-.45-1-1-1s-1 .45-1 1c0 .56.45 1 1 1m5.45-1H17c.55 0 1 .45 1 1v12c0 .56-.45 1-1 1H3c-.55 0-1-.44-1-1V5c0-.55.45-1 1-1h1.55L4 4.63V7h12V4.63zM14 11V9H6v2h3v5h2v-5z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorPasteWord: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.38 2L15 5v1H5V5l2.64-3zM10 5c.55 0 1-.45 1-1s-.45-1-1-1s-1 .45-1 1s.45 1 1 1m8 12V5c0-.55-.45-1-1-1h-1.54l.54.63V7H4V4.62L4.55 4H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1m-3-8l-2 7h-2l-1-5l-1 5H6.92L5 9h2l1 5l1-5h2l1 5l1-5z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorQuote: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.49 13.22c0-.74-.2-1.38-.61-1.9c-.62-.78-1.83-.88-2.53-.72c-.29-1.65 1.11-3.75 2.92-4.65L7.88 4c-2.73 1.3-5.42 4.28-4.96 8.05C3.21 14.43 4.59 16 6.54 16c.85 0 1.56-.25 2.12-.75s.83-1.18.83-2.03m8.05 0c0-.74-.2-1.38-.61-1.9c-.63-.78-1.83-.88-2.53-.72c-.29-1.65 1.11-3.75 2.92-4.65L15.93 4c-2.73 1.3-5.41 4.28-4.95 8.05c.29 2.38 1.66 3.95 3.61 3.95c.85 0 1.56-.25 2.12-.75s.83-1.18.83-2.03\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorRemoveformatting: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m14.29 4.59l1.1 1.11c.41.4.61.94.61 1.47v2.12c0 .53-.2 1.07-.61 1.47l-6.63 6.63c-.4.41-.94.61-1.47.61s-1.07-.2-1.47-.61l-1.11-1.1l-1.1-1.11c-.41-.4-.61-.94-.61-1.47v-2.12c0-.54.2-1.07.61-1.48l6.63-6.62c.4-.41.94-.61 1.47-.61s1.06.2 1.47.61zm-6.21 9.7l6.42-6.42c.39-.39.39-1.03 0-1.43L12.36 4.3c-.19-.19-.45-.29-.72-.29s-.52.1-.71.29l-6.42 6.42c-.39.4-.39 1.04 0 1.43l2.14 2.14c.38.38 1.04.38 1.43 0\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorRtl: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13 2H5.5C3 2 1 4 1 6.5S3 11 5.5 11H6v6c0 .5.5 1 1 1s1-.5 1-1V5c0-.5.5-1 1-1s1 .5 1 1v12c0 .5.5 1 1 1s1-.5 1-1V4h1c.5 0 1-.5 1-1s-.5-1-1-1m1 8l5 4V6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorSpellcheck: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15.84 2.76c.25 0 .49.04.71.11c.23.07.44.16.64.25l.35-.81c-.52-.26-1.08-.39-1.69-.39c-.58 0-1.09.13-1.52.37q-.645.375-.99 1.08C13.11 3.83 13 4.38 13 5c0 .99.23 1.75.7 2.28s1.15.79 2.02.79c.6 0 1.13-.09 1.6-.26v-.84c-.26.08-.51.14-.74.19c-.24.05-.49.08-.74.08c-.59 0-1.04-.19-1.34-.57c-.32-.37-.47-.93-.47-1.66q0-1.05.48-1.65c.33-.4.77-.6 1.33-.6M6.5 8h1.04L5.3 2H4.24L2 8h1.03l.58-1.66H5.9zM8 2v6h2.17c.67 0 1.19-.15 1.57-.46c.38-.3.56-.72.56-1.26c0-.4-.1-.72-.3-.95c-.19-.24-.5-.39-.93-.47v-.04c.35-.06.6-.21.78-.44c.18-.24.28-.53.28-.88c0-.52-.19-.9-.56-1.14c-.36-.24-.96-.36-1.79-.36zm.98 2.48V2.82h.85c.44 0 .77.06.97.19c.21.12.31.33.31.61c0 .31-.1.53-.29.66c-.18.13-.48.2-.89.2zM5.64 5.5H3.9l.54-1.56c.14-.4.25-.76.32-1.1l.15.52c.07.23.13.4.17.51zm3.34-.23h.99c.44 0 .76.08.98.23c.21.15.32.38.32.69c0 .34-.11.59-.32.75s-.52.24-.93.24H8.98zM4 13l5 5l9-8l-1-1l-8 6l-4-3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorStrikethrough: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15.82 12.25c.26 0 .5-.02.74-.07c.23-.05.48-.12.73-.2v.84c-.46.17-.99.26-1.58.26c-.88 0-1.54-.26-2.01-.79c-.39-.44-.62-1.04-.68-1.79h-.94c.12.21.18.48.18.79c0 .54-.18.95-.55 1.26q-.57.45-1.56.45H8v-2.5H6.59l.93 2.5H6.49l-.59-1.67H3.62L3.04 13H2l.93-2.5H2v-1h1.31l.93-2.49H5.3l.92 2.49H8V7h1.77c1 0 1.41.17 1.77.41c.37.24.55.62.55 1.13q0 .525-.27.87l-.08.09h1.29c.05-.4.15-.77.31-1.1c.23-.46.55-.82.98-1.06c.43-.25.93-.37 1.51-.37c.61 0 1.17.12 1.69.38l-.35.81c-.2-.1-.42-.18-.64-.25s-.46-.11-.71-.11c-.55 0-.99.2-1.31.59c-.23.29-.38.66-.44 1.11H17v1h-2.95c.06.5.2.9.44 1.19c.3.37.75.56 1.33.56M4.44 8.96l-.18.54H5.3l-.22-.61c-.04-.11-.09-.28-.17-.51c-.07-.24-.12-.41-.14-.51c-.08.33-.18.69-.33 1.09m4.53-1.09V9.5h1.19c.28-.02.49-.09.64-.18c.19-.13.28-.35.28-.66c0-.28-.1-.48-.3-.61c-.2-.12-.53-.18-.97-.18zm-3.33 2.64v-.01H3.91v.01zm5.28.01l-.03-.02H8.97v1.68h1.04c.4 0 .71-.08.92-.23c.21-.16.31-.4.31-.74c0-.31-.11-.54-.32-.69\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorTable: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 17V3H2v14zM16 7H4V5h12zm-7 4H4V9h5zm7 0h-5V9h5zm-7 4H4v-2h5zm7 0h-5v-2h5z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorTextcolor: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.23 15h1.9L11 4H9L5 15h1.88l1.07-3h4.18zm-1.53-4.54H8.51L10 5.6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorUl: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.5 7C4.67 7 4 6.33 4 5.5C4 4.68 4.67 4 5.5 4C6.32 4 7 4.68 7 5.5C7 6.33 6.32 7 5.5 7M8 5h9v1H8zm-2.5 7c-.83 0-1.5-.67-1.5-1.5C4 9.68 4.67 9 5.5 9c.82 0 1.5.68 1.5 1.5c0 .83-.68 1.5-1.5 1.5M8 10h9v1H8zm-2.5 7c-.83 0-1.5-.67-1.5-1.5c0-.82.67-1.5 1.5-1.5c.82 0 1.5.68 1.5 1.5c0 .83-.68 1.5-1.5 1.5M8 15h9v1H8z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorUnderline: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14 5h-2v5.71c0 1.99-1.12 2.98-2.45 2.98c-1.32 0-2.55-1-2.55-2.96V5H5v5.87c0 1.91 1 4.54 4.48 4.54c3.49 0 4.52-2.58 4.52-4.5zm0 13v-2H5v2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorUnlink: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17.74 2.26a4.32 4.32 0 0 1 0 6.1l-1.53 1.52c-.32.33-.69.58-1.08.77L13 10l1.69-1.64l.76-.77l.76-.76c.84-.84.84-2.2 0-3.04a2.13 2.13 0 0 0-3.04 0l-.77.76l-.76.76L10 7l-.65-2.14c.19-.38.44-.75.77-1.07l1.52-1.53a4.32 4.32 0 0 1 6.1 0M2 4l8 6l-6-8zm4-2l4 8l-2-8zM2 6l8 4l-8-2zm7.36 7.69L10 13l.74 2.35l-1.38 1.39a4.32 4.32 0 0 1-6.1 0a4.32 4.32 0 0 1 0-6.1l1.39-1.38L7 10l-.69.64l-1.52 1.53c-.85.84-.85 2.2 0 3.04c.84.85 2.2.85 3.04 0zM18 16l-8-6l6 8zm-4 2l-4-8l2 8zm4-4l-8-4l8 2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEditorVideo: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16 2h-3v1H7V2H4v15h3v-1h6v1h3zM6 3v1H5V3zm9 0v1h-1V3zm-2 1v5H7V4zM6 5v1H5V5zm9 0v1h-1V5zM6 7v1H5V7zm9 0v1h-1V7zM6 9v1H5V9zm9 0v1h-1V9zm-2 1v5H7v-5zm-7 1v1H5v-1zm9 0v1h-1v-1zm-9 2v1H5v-1zm9 0v1h-1v-1zm-9 2v1H5v-1zm9 0v1h-1v-1z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEllipsis: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 10c0 1.1-.9 2-2 2s-2-.9-2-2s.9-2 2-2s2 .9 2 2m12-2c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m-7 0c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEmail: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.87 4h13.25C18.37 4 19 4.59 19 5.79v8.42c0 1.19-.63 1.79-1.88 1.79H3.87c-1.25 0-1.88-.6-1.88-1.79V5.79c0-1.2.63-1.79 1.88-1.79m6.62 8.6l6.74-5.53c.24-.2.43-.66.13-1.07c-.29-.41-.82-.42-1.17-.17l-5.7 3.86L4.8 5.83c-.35-.25-.88-.24-1.17.17c-.3.41-.11.87.13 1.07z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEmailAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19 14.5v-9c0-.83-.67-1.5-1.5-1.5H3.49c-.83 0-1.5.67-1.5 1.5v9c0 .83.67 1.5 1.5 1.5H17.5c.83 0 1.5-.67 1.5-1.5m-1.31-9.11c.33.33.15.67-.03.84L13.6 9.95l3.9 4.06c.12.14.2.36.06.51c-.13.16-.43.15-.56.05l-4.37-3.73l-2.14 1.95l-2.13-1.95l-4.37 3.73c-.13.1-.43.11-.56-.05c-.14-.15-.06-.37.06-.51l3.9-4.06l-4.06-3.72c-.18-.17-.36-.51-.03-.84s.67-.17.95.07l6.24 5.04l6.25-5.04c.28-.24.62-.4.95-.07\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEmailAlt2: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16 1.1L4 5.9c-1.1.4-2 1.8-2 3v8.7c0 1.2.9 1.8 2 1.4l12-4.8c1.1-.4 2-1.8 2-3V2.5c0-1.2-.9-1.8-2-1.4m.6 2.6l-6 9.3l-6.7-4.5c-.1-.1-.4-.4-.2-.7c.2-.4.7-.2.7-.2l6.3 2.3s4.8-6.3 5.1-6.7c.1-.2.4-.3.7-.1s.2.5.1.6\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEmbedAudio: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 4H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m-7 3H7v4c0 1.1-.9 2-2 2s-2-.9-2-2s.9-2 2-2c.4 0 .7.1 1 .3V5h4zm4 3.5L12.5 12l1.5 1.5V15l-3-3l3-3zm1 4.5v-1.5l1.5-1.5l-1.5-1.5V9l3 3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEmbedGeneric: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 4H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m-3 6.5L12.5 12l1.5 1.5V15l-3-3l3-3zm1 4.5v-1.5l1.5-1.5l-1.5-1.5V9l3 3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEmbedPhoto: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 4H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m-7 8H3V6h7zm4-1.5L12.5 12l1.5 1.5V15l-3-3l3-3zm1 4.5v-1.5l1.5-1.5l-1.5-1.5V9l3 3zm-6-4V8.5L7.2 10L6 9.2L4 11zM4.6 8.6c.6 0 1-.4 1-1s-.4-1-1-1s-1 .4-1 1s.4 1 1 1\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEmbedPost: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 4H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2M8.6 9l-.4.3c-.4.4-.5 1.1-.2 1.6l-.8.8l-1.1-1.1l-1.3 1.3c-.2.2-1.6 1.3-1.8 1.1s.9-1.6 1.1-1.8l1.3-1.3l-1.1-1.1l.8-.8c.5.3 1.2.3 1.6-.2l.3-.3c.5-.5.5-1.2.2-1.7L8 5l3 2.9l-.8.8c-.5-.2-1.2-.2-1.6.3m5.4 1.5L12.5 12l1.5 1.5V15l-3-3l3-3zm1 4.5v-1.5l1.5-1.5l-1.5-1.5V9l3 3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsEmbedVideo: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 4H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m-7 6.5L8 9.1V11H3V6h5v1.8l2-1.3zm4 0L12.5 12l1.5 1.5V15l-3-3l3-3zm1 4.5v-1.5l1.5-1.5l-1.5-1.5V9l3 3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsExcerptView: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19 18V2c0-.55-.45-1-1-1H2c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h16c.55 0 1-.45 1-1M4 3c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m13 0v6H6V3zM4 11c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m13 0v6H6v-6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsExit: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13 3v2h2v10h-2v2h4V3zm0 8V9H5.4l4.3-4.3l-1.4-1.4L1.6 10l6.7 6.7l1.4-1.4L5.4 11z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsExternal: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 3h8v8l-2-1V6.92l-5.6 5.59l-1.41-1.41L14.08 5H10zm3 12v-3l2-2v7H3V6h8L9 8H5v7z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsFacebook: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2.89 2h14.23c.49 0 .88.39.88.88v14.24c0 .48-.39.88-.88.88h-4.08v-6.2h2.08l.31-2.41h-2.39V7.85c0-.7.2-1.18 1.2-1.18h1.28V4.51c-.22-.03-.98-.09-1.86-.09c-1.85 0-3.11 1.12-3.11 3.19v1.78H8.46v2.41h2.09V18H2.89a.89.89 0 0 1-.89-.88V2.88c0-.49.4-.88.89-.88\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsFacebookAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8.46 18h2.93v-7.3h2.45l.37-2.84h-2.82V6.04c0-.82.23-1.38 1.41-1.38h1.51V2.11c-.26-.03-1.15-.11-2.19-.11c-2.18 0-3.66 1.33-3.66 3.76v2.1H6v2.84h2.46z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsFeedback: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 2h16c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1H2c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1m15 14V7H3v9zM4 8v1h3V8zm4 0v3h8V8zm-4 4v1h3v-1zm4 0v3h8v-3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsFilter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 4.5v-2s3.34-1 7-1s7 1 7 1v2l-5 7.03v6.97s-1.22-.09-2.25-.59S8 16.5 8 16.5v-4.97z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsFlag: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 18V3H3v15zm1-6V4c3-1 7 1 11 0v8c-3 1.27-8-1-11 0\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsFood: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 4.5c-.3 0-.5.3-.5.5v2.5h-1V5c0-.3-.2-.5-.5-.5s-.5.3-.5.5v2.5h-1V5c0-.3-.2-.5-.5-.5s-.5.3-.5.5v3.3c0 .9.7 1.6 1.5 1.7v7c0 .6.4 1 1 1s1-.4 1-1v-7c.8-.1 1.5-.8 1.5-1.7V5c0-.2-.2-.5-.5-.5M9 5v6h1v6c0 .6.4 1 1 1s1-.4 1-1V2c-1.7 0-3 1.3-3 3m7-1c-1.4 0-2.5 1.5-2.5 3.3c-.1 1.2.5 2.3 1.5 3V17c0 .6.4 1 1 1s1-.4 1-1v-6.7c1-.7 1.6-1.8 1.5-3C18.5 5.5 17.4 4 16 4\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsFormatAside: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 1h18v12l-6 6H1zm3 3v1h12V4zm0 4v1h12V8zm6 5v-1H4v1zm2 4l5-5h-5z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsFormatAudio: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m6.99 3.08l11.02-2c.55-.08.99.45.99 1V14.5c0 1.94-1.57 3.5-3.5 3.5S12 16.44 12 14.5c0-1.93 1.57-3.5 3.5-3.5c.54 0 1.04.14 1.5.35V5.08l-9 2V16c-.24 1.7-1.74 3-3.5 3C2.57 19 1 17.44 1 15.5C1 13.57 2.57 12 4.5 12c.54 0 1.04.14 1.5.35V4.08c0-.55.44-.91.99-1\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsFormatChat: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 6h-.82C9.07 6 8 7.2 8 8.16V10l-3 3v-3H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zm0 1h6c1.1 0 2 .9 2 2v5c0 1.1-.9 2-2 2h-2v3l-3-3h-1c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsFormatGallery: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16 4h1.96c.57 0 1.04.47 1.04 1.04v12.92c0 .57-.47 1.04-1.04 1.04H5.04C4.47 19 4 18.53 4 17.96V16H2.04C1.47 16 1 15.53 1 14.96V2.04C1 1.47 1.47 1 2.04 1h12.92c.57 0 1.04.47 1.04 1.04zM3 14h11V3H3zm5-8.5C8 4.67 7.33 4 6.5 4S5 4.67 5 5.5S5.67 7 6.5 7S8 6.33 8 5.5m2 4.5s1-5 3-5v8H4V7c2 0 2 3 2 3s.33-2 2-2s2 2 2 2m7 7V6h-1v8.96c0 .57-.47 1.04-1.04 1.04H6v1z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsFormatImage: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2.25 1h15.5c.69 0 1.25.56 1.25 1.25v15.5c0 .69-.56 1.25-1.25 1.25H2.25C1.56 19 1 18.44 1 17.75V2.25C1 1.56 1.56 1 2.25 1M17 17V3H3v14zM10 6c0-1.1-.9-2-2-2s-2 .9-2 2s.9 2 2 2s2-.9 2-2m3 5s0-6 3-6v10c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1V8c2 0 3 4 3 4s1-3 3-3s3 2 3 2\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsFormatQuote: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8.54 12.74q0-1.305-.72-2.22c-.73-.92-2.14-1.03-2.96-.85c-.34-1.93 1.3-4.39 3.42-5.45L6.65 1.94C3.45 3.46.31 6.96.85 11.37C1.19 14.16 2.8 16 5.08 16c1 0 1.83-.29 2.48-.88c.66-.59.98-1.38.98-2.38m9.43 0q0-1.305-.72-2.22c-.73-.92-2.14-1.03-2.96-.85c-.34-1.93 1.3-4.39 3.42-5.45l-1.63-2.28c-3.2 1.52-6.34 5.02-5.8 9.43c.34 2.79 1.95 4.63 4.23 4.63c1 0 1.83-.29 2.48-.88c.66-.59.98-1.38.98-2.38\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsFormatStatus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 1c7 0 9 2.91 9 6.5S17 14 10 14s-9-2.91-9-6.5S3 1 10 1M5.5 9C6.33 9 7 8.33 7 7.5S6.33 6 5.5 6S4 6.67 4 7.5S4.67 9 5.5 9M10 9c.83 0 1.5-.67 1.5-1.5S10.83 6 10 6s-1.5.67-1.5 1.5S9.17 9 10 9m4.5 0c.83 0 1.5-.67 1.5-1.5S15.33 6 14.5 6S13 6.67 13 7.5S13.67 9 14.5 9M6 14.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5m-3 2c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsFormatVideo: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 1h16c.55 0 1 .45 1 1v16l-18-.02V2c0-.55.45-1 1-1m4 1L4 5h1l2-3zm4 0H9L7 5h1zm3 0h-1l-2 3h1zm3 0h-1l-2 3h1zm1 14V6H3v10zM8 7l6 4l-6 4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsForms: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 2h7v7H2zm9 0v7h7V2zM5.5 4.5L7 3H4zM12 8V3h5v5zM4.5 5.5L3 4v3zM8 4L6.5 5.5L8 7zM5.5 6.5L4 8h3zM9 18v-7H2v7zm9 0h-7v-7h7zM8 12v5H3v-5zm6.5 1.5L16 12h-3zM12 16l1.5-1.5L12 13zm3.5-1.5L17 16v-3zm-1 1L13 17h3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsFullscreenAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 2H2v5l1.8-1.8L6.5 8L8 6.5L5.2 3.8zm6 0l1.8 1.8L12 6.5L13.5 8l2.7-2.7L18 7V2zm.5 10L12 13.5l2.7 2.7L13 18h5v-5l-1.8 1.8zm-7 0l-2.7 2.7L2 13v5h5l-1.8-1.8L8 13.5z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsFullscreenExitAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.4 2L2 3.4l2.8 2.8L3 8h5V3L6.2 4.8zm11.8 4.2L18 3.4L16.6 2l-2.8 2.8L12 3v5h5zM4.8 13.8L2 16.6L3.4 18l2.8-2.8L8 17v-5H3zM17 12h-5v5l1.8-1.8l2.8 2.8l1.4-1.4l-2.8-2.8z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsGames: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15.9 5.5C15.3 4.5 14.2 4 13 4H7c-1.2 0-2.3.5-2.9 1.5c-2.3 3.5-2.8 8.8-1.2 9.9s5.2-3.7 7.1-3.7s5.4 4.8 7.1 3.7c1.6-1.1 1.1-6.4-1.2-9.9M8 9H7v1H6V9H5V8h1V7h1v1h1zm5.4.5c0 .5-.4.9-.9.9s-.9-.4-.9-.9s.4-.9.9-.9s.9.4.9.9m1.9-2c0 .5-.4.9-.9.9s-.9-.4-.9-.9s.4-.9.9-.9s.9.4.9.9\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsGoogle: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M17.6 8.5h-7.5v3h4.4c-.4 2.1-2.3 3.5-4.4 3.4c-2.6-.1-4.6-2.1-4.7-4.7c-.1-2.7 2-5 4.7-5.1c1.1 0 2.2.4 3.1 1.2l2.3-2.2C14.1 2.7 12.1 2 10.2 2c-4.4 0-8 3.6-8 8s3.6 8 8 8c4.6 0 7.7-3.2 7.7-7.8c-.1-.6-.1-1.1-.3-1.7\" clip-rule=\"evenodd\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsGoogleplus: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M17.6 8.5h-7.5v3h4.4c-.4 2.1-2.3 3.5-4.4 3.4c-2.6-.1-4.6-2.1-4.7-4.7c-.1-2.7 2-5 4.7-5.1c1.1 0 2.2.4 3.1 1.2l2.3-2.2C14.1 2.7 12.1 2 10.2 2c-4.4 0-8 3.6-8 8s3.6 8 8 8c4.6 0 7.7-3.2 7.7-7.8c-.1-.6-.1-1.1-.3-1.7\" clip-rule=\"evenodd\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsGridView: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 1h16c.55 0 1 .45 1 1v16c0 .55-.45 1-1 1H2c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1m7.01 7.99v-6H3v6zm8 0v-6h-6v6zm-8 8.01v-6H3v6zm8 0v-6h-6v6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsGroups: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8.03 4.46c-.29 1.28.55 3.46 1.97 3.46c1.41 0 2.25-2.18 1.96-3.46c-.22-.98-1.08-1.63-1.96-1.63c-.89 0-1.74.65-1.97 1.63m-4.13.9c-.25 1.08.47 2.93 1.67 2.93s1.92-1.85 1.67-2.93c-.19-.83-.92-1.39-1.67-1.39s-1.48.56-1.67 1.39m8.86 0c-.25 1.08.47 2.93 1.66 2.93c1.2 0 1.92-1.85 1.67-2.93c-.19-.83-.92-1.39-1.67-1.39c-.74 0-1.47.56-1.66 1.39m-.59 11.43l1.25-4.3C14.2 10 12.71 8.47 10 8.47c-2.72 0-4.21 1.53-3.44 4.02l1.26 4.3C8.05 17.51 9 18 10 18c.98 0 1.94-.49 2.17-1.21m-6.1-7.63c-.49.67-.96 1.83-.42 3.59l1.12 3.79c-.34.2-.77.31-1.2.31c-.85 0-1.65-.41-1.85-1.03l-1.07-3.65c-.65-2.11.61-3.4 2.92-3.4c.27 0 .54.02.79.06c-.1.1-.2.22-.29.33m8.35-.39c2.31 0 3.58 1.29 2.92 3.4l-1.07 3.65c-.2.62-1 1.03-1.85 1.03c-.43 0-.86-.11-1.2-.31l1.11-3.77c.55-1.78.08-2.94-.42-3.61c-.08-.11-.18-.23-.28-.33c.25-.04.51-.06.79-.06\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsHammer: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m17.7 6.32l1.41 1.42l-3.47 3.41l-1.42-1.42l.84-.82c-.32-.76-.81-1.57-1.51-2.31l-4.61 6.59l-5.26 4.7c-.39.39-1.02.39-1.42 0l-1.2-1.21a.996.996 0 0 1 0-1.41l10.97-9.92c-1.37-.86-3.21-1.46-5.67-1.48c2.7-.82 4.95-.93 6.58-.3c1.7.66 2.82 2.2 3.91 3.58z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsHeading: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.5 4v5.2h-5V4H5v13h2.5v-5.2h5V17H15V4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsHeart: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 17.12c3.33-1.4 5.74-3.79 7.04-6.21c1.28-2.41 1.46-4.81.32-6.25c-1.03-1.29-2.37-1.78-3.73-1.74s-2.68.63-3.63 1.46c-.95-.83-2.27-1.42-3.63-1.46s-2.7.45-3.73 1.74c-1.14 1.44-.96 3.84.34 6.25c1.28 2.42 3.69 4.81 7.02 6.21\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsHidden: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17.3 3.3c-.4-.4-1.1-.4-1.6 0l-2.4 2.4a9.6 9.6 0 0 0-3.3-.6c-3.8.1-7.2 2.1-9 5.4c.2.4.5.8.8 1.2c.8 1.1 1.8 2 2.9 2.7L3 16.1c-.4.4-.5 1.1 0 1.6c.4.4 1.1.5 1.6 0L17.3 4.9c.4-.5.4-1.2 0-1.6m-10.6 9l-1.3 1.3c-1.2-.7-2.3-1.7-3.1-2.9C3.5 9 5.1 7.8 7 7.2c-1.3 1.4-1.4 3.6-.3 5.1M10.1 9c-.5-.5-.4-1.3.1-1.8c.5-.4 1.2-.4 1.7 0zm8.2.5c-.5-.7-1.1-1.4-1.8-1.9l-1 1c.8.6 1.5 1.3 2.1 2.2C15.9 13.4 13 15 9.9 15h-.8l-1 1c.7-.1 1.3 0 1.9 0c3.3 0 6.4-1.6 8.3-4.3c.3-.4.5-.8.8-1.2c-.3-.3-.5-.7-.8-1M14 10l-4 4c2.2 0 4-1.8 4-4\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsHourglass: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15.5 16H15c-.1-2.5-.6-4.4-3.3-6c2.6-1.6 3.2-3.5 3.3-6h.5c.6 0 1-.4 1-1s-.4-1-1-1h-11c-.6 0-1 .4-1 1s.4 1 1 1H5c.1 2.5.6 4.4 3.3 6c-2.6 1.6-3.2 3.5-3.3 6h-.5c-.6 0-1 .4-1 1s.4 1 1 1h11c.6 0 1-.4 1-1s-.4-1-1-1\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsHtml: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 16v-2H2v2H1v-5h1v2h2v-2h1v5zm3 0v-4H5.6v-1h3.7v1H8v4zm3 0v-5h1l1.4 3.4h.1L14 11h1v5h-1v-3.1h-.1l-1.1 2.5h-.6l-1.1-2.5H11V16zm9 0h-3v-5h1v4h2zM9.4 4.2L7.1 6.5l2.3 2.3l-.6 1.2l-3.5-3.5L8.8 3zm1.2 4.6l2.3-2.3l-2.3-2.3l.6-1.2l3.5 3.5l-3.5 3.5z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsId: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 16H2V4h16zM7.05 8.53q.195-.105.33-.24c.09-.1.17-.21.24-.34c.07-.14.13-.26.17-.37s.07-.22.1-.34L7.95 7c0-.04.01-.07.01-.09c.05-.32.03-.61-.04-.9c-.08-.28-.23-.52-.46-.72C7.23 5.1 6.95 5 6.6 5c-.2 0-.39.04-.56.11c-.17.08-.31.18-.41.3c-.11.13-.2.27-.27.44q-.105.24-.12.51c-.015.27 0 .36.01.55l.02.09c.01.06.03.15.06.25s.06.21.1.33s.1.25.17.37c.08.12.16.23.25.33s.2.19.34.25c.13.06.28.09.43.09s.3-.03.43-.09M17 9V5h-5v4zm-10.38.83l-1.38-.88c-.41 0-.79.11-1.14.32c-.35.22-.62.5-.81.85c-.19.34-.29.7-.29 1.07v1.25l.2.05c.13.04.31.09.55.14c.24.06.51.12.8.17c.29.06.62.1 1 .14c.37.04.73.06 1.07.06s.69-.02 1.07-.06s.7-.09.98-.14c.27-.05.54-.1.82-.17c.27-.06.45-.11.54-.13q.135-.045.21-.06v-1.25c0-.36-.1-.72-.31-1.07s-.49-.64-.84-.86s-.72-.33-1.11-.33zM17 11v-1h-5v1zm0 2v-1h-5v1zm0 2v-1H3v1z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsIdAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 18H2V2h16zM8.05 7.53q.195-.105.33-.24c.09-.1.17-.21.24-.34c.07-.14.13-.26.17-.37s.07-.22.1-.34L8.95 6c0-.04.01-.07.01-.09c.05-.32.03-.61-.04-.9c-.08-.28-.23-.52-.46-.72C8.23 4.1 7.95 4 7.6 4c-.2 0-.39.04-.56.11c-.17.08-.31.18-.41.3c-.11.13-.2.27-.27.44q-.105.24-.12.51c-.015.27 0 .36.01.55l.02.09c.01.06.03.15.06.25s.06.21.1.33s.1.25.17.37c.08.12.16.23.25.33s.2.19.34.25c.13.06.28.09.43.09s.3-.03.43-.09M16 5V4h-5v1zm0 2V6h-5v1zM7.62 8.83l-1.38-.88c-.41 0-.79.11-1.14.32c-.35.22-.62.5-.81.85c-.19.34-.29.7-.29 1.07v1.25l.2.05c.13.04.31.09.55.14c.24.06.51.12.8.17c.29.06.62.1 1 .14c.37.04.73.06 1.07.06s.69-.02 1.07-.06s.7-.09.98-.14c.27-.05.54-.1.82-.17c.27-.06.45-.11.54-.13q.135-.045.21-.06v-1.25c0-.36-.1-.72-.31-1.07s-.49-.64-.84-.86s-.72-.33-1.11-.33zM16 9V8h-3v1zm0 2v-1h-3v1zm0 3v-1H4v1zm0 2v-1H4v1z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsImageCrop: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19 12v3h-4v4h-3v-4H4V7H0V4h4V0h3v4h7l3-3l1 1l-3 3v7zm-8-5H7v4zm-3 5h4V8z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsImageFilter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14 5.87c0-2.2-1.79-4-4-4s-4 1.8-4 4c0 2.21 1.79 4 4 4s4-1.79 4-4M3.24 10.66a3.995 3.995 0 0 0-1.47 5.46a4.006 4.006 0 0 0 5.47 1.47a4.003 4.003 0 0 0 1.46-5.47c-1.1-1.91-3.55-2.56-5.46-1.46m9.52 6.93c1.92 1.1 4.36.45 5.47-1.46c1.1-1.92.45-4.36-1.47-5.47c-1.91-1.1-4.36-.45-5.46 1.46a4.003 4.003 0 0 0 1.46 5.47\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsImageFlipHorizontal: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19 3v14h-8v3H9v-3H1V3h8V0h2v3zm-8.5 14V3h-1v14zM7 6.5L3 10l4 3.5zM17 10l-4-3.5v7z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsImageFlipVertical: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M20 9v2h-3v8H3v-8H0V9h3V1h14v8zM6.5 7h7L10 3zM17 9.5H3v1h14zM13.5 13h-7l3.5 4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsImageRotate: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.25 1.02c5.1 0 8.75 4.04 8.75 9s-3.65 9-8.75 9a9.32 9.32 0 0 1-7.68-3.99l2.59-1.52c1.1 1.5 2.86 2.51 4.84 2.51c3.3 0 6-2.79 6-6s-2.7-6-6-6c-1.97 0-3.72 1-4.82 2.49L7 8.02l-6 2v-7L2.89 4.6a9.32 9.32 0 0 1 7.36-3.58\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsImageRotateLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 5H5.05c0-1.74.85-2.9 2.95-2.9V0C4.85 0 2.96 2.11 2.96 5H1.18L3.8 8.39zm13-4v14h-5v5H1V10h9V1zm-2 2h-6v7h3v3h3zm-5 9H3v6h10z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsImageRotateRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15.95 5H14l3.2 3.39L19.82 5h-1.78c0-2.89-1.89-5-5.04-5v2.1c2.1 0 2.95 1.16 2.95 2.9M1 1h10v9h9v10H6v-5H1zm2 2v10h3v-3h3V3zm5 9v6h10v-6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsImagesAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 15v-3H2V2h12v3h2v3h2v10H6v-3zm7-12c-1.1 0-2 .9-2 2h4a2 2 0 0 0-2-2m-7 8V6H3v5zm7-3h4a2 2 0 1 0-4 0m-5 6V9H5v5zm9-1a2 2 0 1 0 .001-3.999A2 2 0 0 0 15 13m2 4v-2c-5 0-5-3-10-3v5z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsImagesAlt2: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 3h14v11h-2v2h-2v2H1V7h2V5h2zm13 10V4H6v9zm-3-4c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2m1 6v-1H5V6H4v9zM7 6l10 6H7zm7 11v-1H3V8H2v9z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsIndexCard: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 3.17V18h18V4H8v-.83c0-.32-.12-.6-.35-.83S7.14 2 6.82 2H2.18c-.33 0-.6.11-.83.34c-.24.23-.35.51-.35.83M10 6v2H3V6zm7 0v10h-5V6zm-7 4v2H3v-2zm0 4v2H3v-2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsInfo: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 2c4.42 0 8 3.58 8 8s-3.58 8-8 8s-8-3.58-8-8s3.58-8 8-8m1 4c0-.55-.45-1-1-1s-1 .45-1 1s.45 1 1 1s1-.45 1-1m0 9V9H9v6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsInfoOutline: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 15h2V9H9zm1-10c-.5 0-1 .5-1 1s.5 1 1 1s1-.5 1-1s-.5-1-1-1m0-4c-5 0-9 4-9 9s4 9 9 9s9-4 9-9s-4-9-9-9m0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7s7 3.1 7 7s-3.1 7-7 7\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsInsert: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 1c-5 0-9 4-9 9s4 9 9 9s9-4 9-9s-4-9-9-9m0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7s7 3.1 7 7s-3.1 7-7 7m1-11H9v3H6v2h3v3h2v-3h3V9h-3z\" class=\"st0\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsInsertAfter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 12h2v-2h2V8h-2V6H9v2H7v2h2zm1 4c3.9 0 7-3.1 7-7s-3.1-7-7-7s-7 3.1-7 7s3.1 7 7 7m0-12c2.8 0 5 2.2 5 5s-2.2 5-5 5s-5-2.2-5-5s2.2-5 5-5M3 19h14v-2H3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsInsertBefore: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 8H9v2H7v2h2v2h2v-2h2v-2h-2zm-1-4c-3.9 0-7 3.1-7 7s3.1 7 7 7s7-3.1 7-7s-3.1-7-7-7m0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5s5 2.2 5 5s-2.2 5-5 5M3 1v2h14V1z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsInstagram: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.7 10c0-1.5-1.2-2.7-2.7-2.7S7.3 8.5 7.3 10s1.2 2.7 2.7 2.7s2.7-1.2 2.7-2.7m1.4 0c0 2.3-1.8 4.1-4.1 4.1S5.9 12.3 5.9 10S7.7 5.9 10 5.9s4.1 1.8 4.1 4.1m1.1-4.3c0 .6-.4 1-1 1s-1-.4-1-1s.4-1 1-1s1 .5 1 1M10 3.4c-1.2 0-3.7-.1-4.7.3c-.7.3-1.3.9-1.5 1.6c-.4 1-.3 3.5-.3 4.7s-.1 3.7.3 4.7c.2.7.8 1.3 1.5 1.5c1 .4 3.6.3 4.7.3s3.7.1 4.7-.3q1.05-.45 1.5-1.5c.4-1.1.3-3.6.3-4.7s.1-3.7-.3-4.7c-.2-.7-.8-1.3-1.5-1.5c-1-.5-3.5-.4-4.7-.4m8 6.6v3.3c0 1.2-.4 2.4-1.3 3.4c-.9.9-2.1 1.3-3.4 1.3H6.7c-1.2 0-2.4-.4-3.4-1.3c-.8-.9-1.3-2.1-1.3-3.4V6.7c0-1.3.5-2.5 1.3-3.4C4.3 2.5 5.5 2 6.7 2h6.6c1.2 0 2.4.4 3.4 1.3c.8.9 1.3 2.1 1.3 3.4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsLaptop: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 3h14c.6 0 1 .4 1 1v10c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V4c0-.6.4-1 1-1m13 2H4v8h12zm-3 1H5v4zm6 11v-1H1v1c0 .6.5 1 1.1 1h15.8c.6 0 1.1-.4 1.1-1\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsLayout: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 2h5v11H2zm6 0h5v5H8zm6 0h4v16h-4zM8 8h5v5H8zm-6 6h11v4H2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsLeftright: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 10.03L9 6v8zM11 6l6 4.03L11 14z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsLightbulb: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 1c3.11 0 5.63 2.52 5.63 5.62c0 1.84-2.03 4.58-2.03 4.58c-.33.44-.6 1.25-.6 1.8v1c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1v-1c0-.55-.27-1.36-.6-1.8c0 0-2.02-2.74-2.02-4.58C4.38 3.52 6.89 1 10 1M7 16.87V16h6v.87c0 .62-.13 1.13-.75 1.13H12c0 .62-.4 1-1.02 1h-2c-.61 0-.98-.38-.98-1h-.25c-.62 0-.75-.51-.75-1.13\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsLinkedin: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2.5 18h3V6.9h-3zM4 2c-1 0-1.8.8-1.8 1.8S3 5.6 4 5.6s1.8-.8 1.8-1.8S5 2 4 2m6.6 6.6V6.9h-3V18h3v-5.7c0-3.2 4.1-3.4 4.1 0V18h3v-6.8c0-5.4-5.7-5.2-7.1-2.6\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsListView: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 19h16c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1H2c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1M4 3c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m13 0v2H6V3zM4 7c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m13 0v2H6V7zM4 11c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m13 0v2H6v-2zM4 15c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m13 0v2H6v-2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsLocation: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 2C6.69 2 4 4.69 4 8c0 2.02 1.17 3.71 2.53 4.89c.43.37 1.18.96 1.85 1.83c.74.97 1.41 2.01 1.62 2.71c.21-.7.88-1.74 1.62-2.71c.67-.87 1.42-1.46 1.85-1.83C14.83 11.71 16 10.02 16 8c0-3.31-2.69-6-6-6m0 2.56a3.44 3.44 0 1 1 0 6.88a3.44 3.44 0 0 1 0-6.88\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsLocationAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m13 13.14l1.17-5.94c.79-.43 1.33-1.25 1.33-2.2a2.5 2.5 0 0 0-5 0c0 .95.54 1.77 1.33 2.2zm0-9.64c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5m1.72 4.8L18 6.97v9L13.12 18L7 15.97l-5 2v-9l5-2l4.27 1.41l1.73 7.3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsLock: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15 9h-1V6c0-2.2-1.8-4-4-4S6 3.8 6 6v3H5c-.5 0-1 .5-1 1v7c0 .5.5 1 1 1h10c.5 0 1-.5 1-1v-7c0-.5-.5-1-1-1m-4 7H9l.4-2.2c-.5-.2-.9-.8-.9-1.3c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5c0 .6-.3 1.1-.9 1.3zm1-7H8V6c0-1.1.9-2 2-2s2 .9 2 2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsLockAlt: Icon = {
  "body": "<path d=\"M15 6v2c1.1 0 2 .9 2 2v7c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-7c0-1.1.9-2 2-2V6c0-2.76 2.24-5 5-5s5 2.24 5 5zM8 6v2h4V6c0-1.1-.9-2-2-2s-2 .9-2 2zm2.8 10.25v-2.17c.7-.31 1.2-1.01 1.2-1.83c0-1.1-.9-2-2-2s-2 .9-2 2c0 .82.5 1.52 1.2 1.83v2.17h1.6z\" fill=\"currentColor\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsLockDuplicate: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15 9h-1V6c0-2.2-1.8-4-4-4S6 3.8 6 6v3H5c-.5 0-1 .5-1 1v7c0 .5.5 1 1 1h10c.5 0 1-.5 1-1v-7c0-.5-.5-1-1-1m-4 7H9l.4-2.2c-.5-.2-.9-.8-.9-1.3c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5c0 .6-.3 1.1-.9 1.3zm1-7H8V6c0-1.1.9-2 2-2s2 .9 2 2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMarker: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 2c4.42 0 8 3.58 8 8s-3.58 8-8 8s-8-3.58-8-8s3.58-8 8-8m0 13c2.76 0 5-2.24 5-5s-2.24-5-5-5s-5 2.24-5 5s2.24 5 5 5\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMediaArchive: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m12 2l4 4v12H4V2zm0 4h3l-3-3zM8 3.5v2l1.8-1zM11 5L9.2 6L11 7zM8 6.5v2l1.8-1zM11 8L9.2 9l1.8 1zM8 9.5v2l1.8-1zm3 1.5l-1.8 1l1.8 1zm-1.5 6c.83 0 1.62-.72 1.5-1.63c-.05-.38-.49-1.61-.49-1.61l-1.99-1.1s-.45 1.95-.52 2.71c-.07.77.67 1.63 1.5 1.63m0-2.39c.42 0 .76.34.76.76c0 .43-.34.77-.76.77s-.76-.34-.76-.77c0-.42.34-.76.76-.76\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMediaAudio: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m12 2l4 4v12H4V2zm0 4h3l-3-3zm1 7.26V8.09a.4.4 0 0 0-.12-.29a.3.3 0 0 0-.27-.1s-3.97.71-4.25.78C8.07 8.54 8 8.8 8 9v3.37c-.2-.09-.42-.07-.6-.07q-.57 0-.96.39c-.26.27-.4.58-.4.96c0 .37.14.69.4.95c.26.27.58.4.96.4c.34 0 .7-.04.96-.26c.26-.23.64-.65.64-1.12V10.3l3-.6V12c-.67-.2-1.17.04-1.44.31c-.26.26-.39.58-.39.95c0 .38.13.69.39.96c.27.26.71.39 1.08.39q.57 0 .96-.39c.26-.27.4-.58.4-.96\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMediaCode: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m12 2l4 4v12H4V2zM9 13l-2-2l2-2l-1-1l-3 3l3 3zm3 1l3-3l-3-3l-1 1l2 2l-2 2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMediaDefault: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m12 2l4 4v12H4V2zm0 4h3l-3-3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMediaDocument: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m12 2l4 4v12H4V2zM5 3v1h6V3zm7 3h3l-3-3zM5 5v1h6V5zm10 3V7H5v1zM5 9v1h4V9zm10 3V9h-5v3zM5 11v1h4v-1zm10 3v-1H5v1zm-3 2v-1H5v1z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMediaInteractive: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m12 2l4 4v12H4V2zm0 4h3l-3-3zm2 8V8H6v6h3l-1 2h1l1-2l1 2h1l-1-2zm-6-3c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m5-2v2h-3V9zm0 3v1H7v-1z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMediaSpreadsheet: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m12 2l4 4v12H4V2zm-1 4V3H5v3zM8 8V7H5v1zm3 0V7H9v1zm4 0V7h-3v1zm-7 2V9H5v1zm3 0V9H9v1zm4 0V9h-3v1zm-7 2v-1H5v1zm3 0v-1H9v1zm4 0v-1h-3v1zm-7 2v-1H5v1zm3 0v-1H9v1zm4 0v-1h-3v1zm-7 2v-1H5v1zm3 0v-1H9v1z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMediaText: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m12 2l4 4v12H4V2zM5 3v1h6V3zm7 3h3l-3-3zM5 5v1h6V5zm10 3V7H5v1zm0 2V9H5v1zm0 2v-1H5v1zm-4 2v-1H5v1z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMediaVideo: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m12 2l4 4v12H4V2zm0 4h3l-3-3zm-1 8v-3c0-.27-.1-.51-.29-.71c-.2-.19-.44-.29-.71-.29H7c-.27 0-.51.1-.71.29c-.19.2-.29.44-.29.71v3c0 .27.1.51.29.71c.2.19.44.29.71.29h3c.27 0 .51-.1.71-.29c.19-.2.29-.44.29-.71m3 1v-5l-2 2v1z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMegaphone: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18.15 5.94c.46 1.62.38 3.22-.02 4.48c-.42 1.28-1.26 2.18-2.3 2.48c-.16.06-.26.06-.4.06c-.06.02-.12.02-.18.02c-.06.02-.14.02-.22.02h-6.8l2.22 5.5c.02.14-.06.26-.14.34c-.08.1-.24.16-.34.16H6.95c-.1 0-.26-.06-.34-.16c-.08-.08-.16-.2-.14-.34l-1-5.5H4.25l-.02-.02c-.5.06-1.08-.18-1.54-.62s-.88-1.08-1.06-1.88c-.24-.8-.2-1.56-.02-2.2c.18-.62.58-1.08 1.06-1.3l.02-.02l9-5.4c.1-.06.18-.1.24-.16q.09-.06.24-.12c.16-.08.28-.12.5-.18c1.04-.3 2.24.1 3.22.98s1.84 2.24 2.26 3.86m-2.58 5.98h-.02c.4-.1.74-.34 1.04-.7c.58-.7.86-1.76.86-3.04c0-.64-.1-1.3-.28-1.98c-.34-1.36-1.02-2.5-1.78-3.24s-1.68-1.1-2.46-.88c-.82.22-1.4.96-1.7 2c-.32 1.04-.28 2.36.06 3.72c.38 1.36 1 2.5 1.8 3.24c.78.74 1.62 1.1 2.48.88m-2.54-7.08c.22-.04.42-.02.62.04c.38.16.76.48 1.02 1s.42 1.2.42 1.78c0 .3-.04.56-.12.8c-.18.48-.44.84-.86.94c-.34.1-.8-.06-1.14-.4s-.64-.86-.78-1.5c-.18-.62-.12-1.24.02-1.72s.48-.84.82-.94\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMenu: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 15h14v-2H3zM3 5v2h14V5zm0 6h14V9H3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMenuAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 11h14V9H3zm0 5h14v-2H3zM3 4v2h14V4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMenuAlt2: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 15h10v-2H5zM5 5v2h10V5zm0 6h10V9H5z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMenuAlt3: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M20 5V2H0v3zm0 6V8H0v3zm0 6v-3H0v3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMenu2: Icon = {
  "body": "<path d=\"M15 7V5H5v2h10zm0 4V9H5v2h10zm0 4v-2H5v2h10z\" fill=\"currentColor\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMicrophone: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 9V3a2 2 0 0 0-2-2c-1.12 0-2 .94-2 2v6c0 1.1.9 2 2 2c1.13 0 2-.94 2-2m4 0c0 2.97-2.16 5.43-5 5.91V17h2c.56 0 1 .45 1 1s-.44 1-1 1H7c-.55 0-1-.45-1-1s.45-1 1-1h2v-2.09C6.17 14.43 4 11.97 4 9c0-.55.45-1 1-1c.56 0 1 .45 1 1a3.999 3.999 0 1 0 8 0c0-.55.45-1 1-1c.56 0 1 .45 1 1\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMigrate: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 6h6V4H2v12.01h8V14H4zm2 2h6V5l6 5l-6 5v-3H6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMinus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 9h12v2H4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMoney: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 3h20v12h-.75c0-1.79-1.46-3.25-3.25-3.25c-1.31 0-2.42.79-2.94 1.91c-.25-.1-.52-.16-.81-.16c-.98 0-1.8.63-2.11 1.5H0zm8.37 3.11c-.06.15-.1.31-.11.47s-.01.33.01.5l.02.08c.01.06.02.14.05.23c.02.1.06.2.1.31c.03.11.09.22.15.33c.07.12.15.22.23.31s.18.17.31.23c.12.06.25.09.4.09q.21 0 .39-.09c.18-.09.22-.14.3-.22c.09-.09.16-.2.22-.32c.07-.12.12-.23.16-.33s.07-.2.09-.31c.03-.11.04-.18.05-.22s.01-.07.01-.09c.05-.29.03-.56-.04-.82s-.21-.48-.41-.66c-.21-.18-.47-.27-.79-.27c-.19 0-.36.03-.52.1c-.15.07-.28.16-.38.28c-.09.11-.17.25-.24.4m4.48 6.04v-1.14c0-.33-.1-.66-.29-.98s-.45-.59-.77-.79c-.32-.21-.66-.31-1.02-.31l-1.24.84l-1.28-.82c-.37 0-.72.1-1.04.3c-.31.2-.56.46-.74.77q-.27.48-.27.99v1.14l.18.05c.12.04.29.08.51.14c.23.05.47.1.74.15c.26.05.57.09.91.13c.34.03.67.05.99.05c.3 0 .63-.02.98-.05c.34-.04.64-.08.89-.13c.25-.04.5-.1.76-.16l.5-.12c.08-.02.14-.04.19-.06m3.15.1c1.52 0 2.75 1.23 2.75 2.75s-1.23 2.75-2.75 2.75c-.73 0-1.38-.3-1.87-.77a2.235 2.235 0 0 0-.62-3.09c.43-.96 1.37-1.64 2.49-1.64m-5.5 3.5c0-.96.79-1.75 1.75-1.75s1.75.79 1.75 1.75s-.79 1.75-1.75 1.75s-1.75-.79-1.75-1.75\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMoneyAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.6 9c-.4-.1-.8-.3-1.1-.6c-.3-.1-.4-.4-.4-.6s.1-.5.3-.6c.3-.2.6-.4.9-.3c.6 0 1.1.3 1.4.7l.9-1.2c-.3-.3-.6-.5-.9-.7s-.7-.3-1.1-.3V4H9.4v1.4c-.5.1-1 .4-1.4.8c-.4.5-.7 1.1-.6 1.7c0 .6.2 1.2.6 1.6c.5.5 1.2.8 1.8 1.1c.3.1.7.3 1 .5c.2.2.3.5.3.8q0 .45-.3.9c-.3.3-.7.4-1 .4c-.4 0-.9-.1-1.2-.4c-.3-.2-.6-.5-.8-.8l-1 1.1c.3.4.6.7 1 1c.5.3 1.1.6 1.7.6V16h1.1v-1.5c.6-.1 1.1-.4 1.5-.8c.5-.5.8-1.3.8-2c0-.6-.2-1.3-.7-1.7c-.5-.5-1-.8-1.6-1M10 2c-4.4 0-8 3.6-8 8s3.6 8 8 8s8-3.6 8-8s-3.6-8-8-8m0 14.9c-3.8 0-6.9-3.1-6.9-6.9S6.2 3.1 10 3.1s6.9 3.1 6.9 6.9s-3.1 6.9-6.9 6.9\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMove: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m19 10l-4 4v-3h-4v4h3l-4 4l-4-4h3v-4H5v3l-4-4l4-4v3h4V5H6l4-4l4 4h-3v4h4V6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsNametag: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 5V2c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h2c.55 0 1-.45 1-1m-2-3c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m8 13V7c0-1.1-.9-2-2-2h-3v.33C13 6.25 12.25 7 11.33 7H8.67C7.75 7 7 6.25 7 5.33V5H4c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2m-1-6v6H3V9zm-8 2c0-.55-.22-1-.5-1s-.5.45-.5 1s.22 1 .5 1s.5-.45.5-1m3 0c0-.55-.22-1-.5-1s-.5.45-.5 1s.22 1 .5 1s.5-.45.5-1m-5.96 1.21c.92.48 2.34.79 3.96.79s3.04-.31 3.96-.79c-.21 1-1.89 1.79-3.96 1.79s-3.75-.79-3.96-1.79\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsNetworking: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 13h1c.55 0 1 .45 1 1.01v2.98c0 .56-.45 1.01-1 1.01h-4c-.55 0-1-.45-1-1.01v-2.98c0-.56.45-1.01 1-1.01h1v-2h-5v2h1c.55 0 1 .45 1 1.01v2.98c0 .56-.45 1.01-1 1.01H8c-.55 0-1-.45-1-1.01v-2.98c0-.56.45-1.01 1-1.01h1v-2H4v2h1c.55 0 1 .45 1 1.01v2.98C6 17.55 5.55 18 5 18H1c-.55 0-1-.45-1-1.01v-2.98C0 13.45.45 13 1 13h1v-2c0-1.1.9-2 2-2h5V7H8c-.55 0-1-.45-1-1.01V3.01C7 2.45 7.45 2 8 2h4c.55 0 1 .45 1 1.01v2.98C13 6.55 12.55 7 12 7h-1v2h5c1.1 0 2 .9 2 2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsNo: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m12.12 10l3.53 3.53l-2.12 2.12L10 12.12l-3.54 3.54l-2.12-2.12L7.88 10L4.34 6.46l2.12-2.12L10 7.88l3.54-3.53l2.12 2.12z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsNoAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14.95 6.46L11.41 10l3.54 3.54l-1.41 1.41L10 11.42l-3.53 3.53l-1.42-1.42L8.58 10L5.05 6.47l1.42-1.42L10 8.58l3.54-3.53z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsOpenFolder: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m10.5 6l-2-2H2l.7 9.5L4.2 6zM5 7L3 17h13l2-10z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsPalmtree: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8.58 2.39c.32 0 .59.05.81.14c1.25.55 1.69 2.24 1.7 3.97c.59-.82 2.15-2.29 3.41-2.29s2.94.73 3.53 3.55c-1.13-.65-2.42-.94-3.65-.94c-1.26 0-2.45.32-3.29.89c.4-.11.86-.16 1.33-.16c1.39 0 2.9.45 3.4 1.31c.68 1.16.47 3.38-.76 4.14c-.14-2.1-1.69-4.12-3.47-4.12c-.44 0-.88.12-1.33.38C8 10.62 7 14.56 7 19H2c0-5.53 4.21-9.65 7.68-10.79c-.56-.09-1.17-.15-1.82-.15C6.1 8.06 4.05 8.5 2 10c.76-2.96 2.78-4.1 4.69-4.1c1.25 0 2.45.5 3.2 1.29c-.66-2.24-2.49-2.86-4.08-2.86c-.8 0-1.55.16-2.05.35c.91-1.29 3.31-2.29 4.82-2.29M13 11.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5s1.5-.67 1.5-1.5\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsPaperclip: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17.05 2.7c1.93 1.94 1.93 5.13 0 7.07L10 16.84c-1.88 1.89-4.91 1.93-6.86.15c-.06-.05-.13-.09-.19-.15c-1.93-1.94-1.93-5.12 0-7.07l4.94-4.95c.91-.92 2.28-1.1 3.39-.58c.3.15.59.33.83.58a3 3 0 0 1 0 4.24l-4.93 4.95a.996.996 0 1 1-1.41-1.41l4.93-4.95a.996.996 0 0 0 0-1.41a.984.984 0 0 0-1.4 0l-4.94 4.95c-.91.92-1.1 2.29-.57 3.4c.14.3.32.59.57.84s.54.43.84.57c1.11.53 2.47.35 3.39-.57l7.05-7.07a3.03 3.03 0 0 0 0-4.25c-.56-.55-1.28-.83-2-.86q-.12.015-.24 0c-.22-.03-.43-.11-.6-.27c-.39-.4-.38-1.05.02-1.45c.16-.16.36-.24.56-.28c.14-.02.27-.01.4.02c1.19.06 2.36.52 3.27 1.43\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsPdf: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.8 14H5v1h.8c.3 0 .5-.2.5-.5s-.2-.5-.5-.5M11 2H3v16h13V7zM7.2 14.6c0 .8-.6 1.4-1.4 1.4H5v1H4v-4h1.8c.8 0 1.4.6 1.4 1.4zm4.1.5c0 1-.8 1.9-1.9 1.9H8v-4h1.4c1 0 1.9.8 1.9 1.9zM15 14h-2v1h1.5v1H13v1h-1v-4h3zm0-2H4V3h7v4h4zm-5.6 2H9v2h.4c.6 0 1-.4 1-1s-.5-1-1-1\" clip-rule=\"evenodd\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsPerformance: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.76 17.01h12.48A8 8 0 0 0 18 12c0-4.41-3.58-8-8-8s-8 3.59-8 8c0 1.9.66 3.63 1.76 5.01M9 6c0-.55.45-1 1-1s1 .45 1 1c0 .56-.45 1-1 1s-1-.44-1-1M4 8c0-.55.45-1 1-1s1 .45 1 1c0 .56-.45 1-1 1s-1-.44-1-1m4.52 3.4c.84-.83 6.51-3.5 6.51-3.5s-2.66 5.68-3.49 6.51c-.84.84-2.18.84-3.02 0a2.13 2.13 0 0 1 0-3.01M3 13c0-.55.45-1 1-1s1 .45 1 1c0 .56-.45 1-1 1s-1-.44-1-1m6 0c0-.55.45-1 1-1s1 .45 1 1c0 .56-.45 1-1 1s-1-.44-1-1m6 0c0-.55.45-1 1-1s1 .45 1 1c0 .56-.45 1-1 1s-1-.44-1-1\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsPets: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11.9 8.4c1.3 0 2.1-1.9 2.1-3.1c0-1-.5-2.2-1.5-2.2c-1.3 0-2.1 1.9-2.1 3.1c0 1 .5 2.2 1.5 2.2m-3.8 0c1 0 1.5-1.2 1.5-2.2C9.6 4.9 8.8 3 7.5 3C6.5 3 6 4.2 6 5.2c-.1 1.3.7 3.2 2.1 3.2m7.4-1c-1.3 0-2.2 1.8-2.2 3.1c0 .9.4 1.8 1.3 1.8c1.3 0 2.2-1.8 2.2-3.1c0-.9-.5-1.8-1.3-1.8m-8.7 3.1c0-1.3-1-3.1-2.2-3.1c-.9 0-1.3.9-1.3 1.8c0 1.3 1 3.1 2.2 3.1c.9 0 1.3-.9 1.3-1.8m3.2-.2c-2 0-4.7 3.2-4.7 5.4c0 1 .7 1.3 1.5 1.3c1.2 0 2.1-.8 3.2-.8c1 0 1.9.8 3 .8c.8 0 1.7-.2 1.7-1.3c0-2.2-2.7-5.4-4.7-5.4\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsPhone: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m12.06 6l-.21-.2c-.52-.54-.43-.79.08-1.3l2.72-2.75c.81-.82.96-1.21 1.73-.48l.21.2zm.53.45l4.4-4.4c.7.94 2.34 3.47 1.53 5.34c-.73 1.67-1.09 1.75-2 3c-1.85 2.11-4.18 4.37-6 6.07c-1.26.91-1.31 1.33-3 2c-1.8.71-4.4-.89-5.38-1.56l4.4-4.4l1.18 1.62c.34.46 1.2-.06 1.8-.66c1.04-1.05 3.18-3.18 4-4.07c.59-.59 1.12-1.45.66-1.8zM1.57 16.5l-.21-.21c-.68-.74-.29-.9.52-1.7l2.74-2.72c.51-.49.75-.6 1.27-.11l.2.21z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsPinterest: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.2 2C5.8 2 3.5 4.8 3.5 7.9c0 1.5.8 3 2.1 3.8c.4.2.3 0 .6-1.2c0-.1 0-.2-.1-.3C4.3 8 5.8 3.7 10 3.7c6.1 0 4.9 8.4 1.1 8.4c-.8.1-1.5-.5-1.5-1.3v-.4c.4-1.1.7-2.1.8-3.2c0-2.1-3.1-1.8-3.1 1c0 .5.1 1 .3 1.4c0 0-1 4.1-1.2 4.8c-.2 1.2-.1 2.4.1 3.5c-.1.1 0 .1 0 .1h.1c.7-1 1.3-2 1.7-3.1c.1-.5.6-2.3.6-2.3c.5.7 1.4 1.1 2.3 1.1c3.1 0 5.3-2.7 5.3-6S13.7 2 10.2 2\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsPlaylistAudio: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 3V1H2v2zm0 4V5H2v2zm-7 4V9H2v2zm7.45-1.96l-6 1.12c-.16.02-.19.03-.29.13c-.11.09-.16.22-.16.37v4.59c-.29-.13-.66-.14-.93-.14q-.81 0-1.38.57c-.57.57-.56.84-.56 1.38c0 .53.18.99.56 1.37s.84.57 1.38.57q.735 0 1.29-.48c.555-.48.59-.71.65-1.19v-4.95L17 11.27v3.48c-.29-.13-.56-.19-.83-.19c-.54 0-1.11.19-1.49.57c-.38.37-.57.83-.57 1.37s.19.99.57 1.37s.84.57 1.38.57c.53 0 .99-.19 1.37-.57s.57-.83.57-1.37V9.6c0-.16-.05-.3-.16-.41a.43.43 0 0 0-.39-.15M8 15v-2H2v2zm-2 4v-2H2v2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsPlaylistVideo: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 3V1H2v2zm0 4V5H2v2zM6 11V9H2v2zm2-2h9c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1m3 7l3.33-2L11 12zm-5-1v-2H2v2zm0 4v-2H2v2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsPluginsChecked: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m13.6 5.1l-3.1 3.1l1.8 1.8l3.1-3.1c.3-.3.2-1-.3-1.5s-1.1-.6-1.5-.3m.3-4.8c-.7-.4-9.8 7.3-9.8 7.3S.6 5.5.1 5.9s4 5 4 5S14.6.6 13.9.3m5.5 9.3c-.5-.5-1.2-.6-1.5-.3l-3.1 3.1l1.8 1.8l3.1-3.2c.3-.2.2-.9-.3-1.4m-11.7-1c-.7.7-1.1 2.7-1.1 3.8v3.8l-1.2 1.2c-.6.6-.6 1.5 0 2.1s1.5.6 2.1 0l1.2-1.2h3.8c1.2 0 3-.4 3.7-1.1l1.2-.8l-8.9-8.9z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsPlus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 7v3h-5v5H9v-5H4V7h5V2h3v5z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsPlusAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15.8 4.2c3.2 3.21 3.2 8.39 0 11.6a8.21 8.21 0 0 1-11.6 0a8.21 8.21 0 0 1 0-11.6C7.41 1 12.59 1 15.8 4.2m-4.3 11.3v-4h4v-3h-4v-4h-3v4h-4v3h4v4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsPlusAlt2: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 9v2h-6v6H9v-6H3V9h6V3h2v6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsPodio: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.2 13.8L9.1 9.7c-.2-.2-.4-.5-.4-.9c0-.7.6-1.3 1.3-1.3c.1 0 .3 0 .4.1c.7.2 1.1.9.9 1.6c-.1.5.1 1 .6 1.1s1-.1 1.1-.6c.1-.3.1-.6.1-.9c0-1.7-1.4-3.1-3.1-3.1c-.8 0-1.6.3-2.2.9c-1.2 1.2-1.2 3.2 0 4.4l4.1 4.1c.4.4.9.4 1.3 0c.4-.3.4-.9 0-1.3M14.9 4C12.2 1.4 8 1.3 5.3 4s-2.7 7 0 9.6l4.1 4.1c.4.4.9.4 1.3 0s.4-.9 0-1.3l-4.1-4.1c-1.9-1.9-1.9-5.1 0-7s5.1-1.9 7 0c1.6 1.7 1.8 4.4.5 6.3c-.3.4-.1 1 .3 1.3s1 .1 1.3-.3c1.7-2.7 1.4-6.3-.8-8.6\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsPortfolio: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 5H.78c-.37 0-.74.32-.69.84l1.56 9.99S3.5 8.47 3.86 6.7c.11-.53.61-.7.98-.7H10s-.7-2.08-.77-2.31C9.11 3.25 8.89 3 8.45 3H5.14c-.36 0-.7.23-.8.64C4.25 4.04 4 5 4 5m4.88 0h-4s.42-1 .87-1h2.13c.48 0 1 1 1 1M2.67 16.25c-.31.47-.76.75-1.26.75h15.73c.54 0 .92-.31 1.03-.83c.44-2.19 1.68-8.44 1.68-8.44c.07-.5-.3-.73-.62-.73H16V5.53c0-.16-.26-.53-.66-.53h-3.76c-.52 0-.87.58-.87.58L10 7H5.59c-.32 0-.63.19-.69.5c0 0-1.59 6.7-1.72 7.33c-.07.37-.22.99-.51 1.42M15.38 7H11s.58-1 1.13-1h2.29c.71 0 .96 1 .96 1\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsPostStatus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14 6c0 1.86-1.28 3.41-3 3.86V16c0 1-2 2-2 2V9.86c-1.72-.45-3-2-3-3.86c0-2.21 1.79-4 4-4s4 1.79 4 4M8 5c0 .55.45 1 1 1s1-.45 1-1s-.45-1-1-1s-1 .45-1 1\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsPressthis: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14.76 1a3.246 3.246 0 0 1 0 6.49c-.23 0-.47-.03-.7-.08L13 8.47V19H2V4h9.54c.13-2 1.52-3 3.22-3m0 5.49a2.245 2.245 0 0 0 0-4.49c-1.24 0-2.24 1.01-2.24 2.25c0 .37.1.72.27 1.03L9.57 8.5c-.28.28-1.77 2.22-1.5 2.49c.02.03.06.04.1.04c.49 0 2.14-1.28 2.39-1.53l3.24-3.24c.29.14.61.23.96.23\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsPrinter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 11H7v1h5zm1 4H7v1h6zm-3-2H7v1h3zm7-7h-2V2H5v4H3c-.6 0-1 .4-1 1v5c0 .6.4 1 1 1h2v5h10v-5h2c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1m-3 11H6v-7h8zm0-11H6V3h8zm2 3h-1V8h1z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsPrivacy: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 9.6c-.6 0-1 .4-1 1c0 .4.3.7.6.8l-.3 1.4h1.3l-.3-1.4c.4-.1.6-.4.6-.8c.1-.6-.3-1-.9-1m.1-4.3c-.7 0-1.4.5-1.4 1.2V8h2.7V6.5c-.1-.7-.6-1.2-1.3-1.2M10 2L3 5v3c.1 4.4 2.9 8.3 7 9.9c4.1-1.6 6.9-5.5 7-9.9V5zm4 11c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9c0-.6.4-1 1-1h.3V6.5C7.4 5.1 8.6 4 10 4s2.6 1.1 2.7 2.5V8h.3c.6 0 1 .4 1 1z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsProducts: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 8h1v11H2V8h1V6c0-2.76 2.24-5 5-5c.71 0 1.39.15 2 .42A4.9 4.9 0 0 1 12 1c2.76 0 5 2.24 5 5zM5 6v2h2V6c0-1.13.39-2.16 1.02-3H8C6.35 3 5 4.35 5 6m10 2V6c0-1.65-1.35-3-3-3h-.02A4.98 4.98 0 0 1 13 6v2zm-5-4.22C9.39 4.33 9 5.12 9 6v2h2V6c0-.88-.39-1.67-1-2.22\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsRandomize: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 6.01L14 9V7h-4l-5 8H2v-2h2l5-8h5V3zM2 5h3l1.15 2.17l-1.12 1.8L4 7H2zm16 9.01L14 17v-2H9l-1.15-2.17l1.12-1.8L10 13h4v-2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsReddit: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 10.1c0-1-.8-1.8-1.8-1.7c-.4 0-.9.2-1.2.5c-1.4-.9-3-1.5-4.7-1.5l.8-3.8l2.6.6c0 .7.6 1.2 1.3 1.2s1.2-.6 1.2-1.3s-.6-1.2-1.3-1.2c-.5 0-.9.3-1.1.7L11 2.9h-.2c-.1 0-.1.1-.1.2l-1 4.3C8 7.4 6.4 7.9 5 8.9c-.7-.7-1.8-.7-2.5 0s-.7 1.8 0 2.5c.1.1.3.3.5.3v.5c0 2.7 3.1 4.9 7 4.9s7-2.2 7-4.9v-.5c.6-.3 1-.9 1-1.6M6 11.4c0-.7.6-1.2 1.2-1.2c.7 0 1.2.6 1.2 1.2s-.6 1.2-1.2 1.2c-.7 0-1.2-.5-1.2-1.2m7 3.3c-.9.6-1.9 1-3 .9q-1.65 0-3-.9c-.1-.1-.1-.3 0-.5c.1-.1.3-.1.4 0c.7.5 1.6.8 2.5.7c.9.1 1.8-.2 2.5-.7c.1-.1.3-.1.5 0s.2.3.1.5m-.3-2.1c-.7 0-1.2-.6-1.2-1.2s.6-1.2 1.2-1.2c.7 0 1.2.6 1.2 1.2c.1.7-.5 1.2-1.2 1.2\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsRedo: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 5h5V2l6 4l-6 4V7H8c-2.2 0-4 1.8-4 4s1.8 4 4 4h5v2H8c-3.3 0-6-2.7-6-6s2.7-6 6-6\" class=\"st0\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsRemove: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 1c-5 0-9 4-9 9s4 9 9 9s9-4 9-9s-4-9-9-9m0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7s7 3.1 7 7s-3.1 7-7 7M6 9v2h8V9z\" class=\"st0\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsRestApi: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16 13c-1.3 0-2.4.8-2.8 2H9c0-.7-.2-1.3-.5-1.8l7.1-7.3c.3 0 .6.1.9.1C17.9 6 19 4.9 19 3.5S17.9 1 16.5 1S14 2.1 14 3.5c0 .3.1.7.2 1l-7 7.2c-.6-.5-1.4-.7-2.2-.7V6.8C6.2 6.4 7 5.3 7 4c0-1.7-1.3-3-3-3S1 2.3 1 4c0 1.3.8 2.4 2 2.8v4.7c-1.2.7-2 2-2 3.4c0 2.2 1.8 4 4 4c1.5 0 2.8-.8 3.4-2h4.7c.4 1.1 1.5 2 2.8 2c1.6 0 3-1.3 3-3C19 14.3 17.6 13 16 13\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsRss: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14.92 18H18C18 9.32 10.82 2.25 2 2.25v3.02c7.12 0 12.92 5.71 12.92 12.73m-5.44 0h3.08C12.56 12.27 7.82 7.6 2 7.6v3.02c2 0 3.87.77 5.29 2.16A7.3 7.3 0 0 1 9.48 18m-5.35-.02c1.17 0 2.13-.93 2.13-2.09c0-1.15-.96-2.09-2.13-2.09c-1.18 0-2.13.94-2.13 2.09c0 1.16.95 2.09 2.13 2.09\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsSaved: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m15.3 5.3l-6.8 6.8l-2.8-2.8l-1.4 1.4l4.2 4.2l8.2-8.2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsSchedule: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 2h16v4H2zm0 10V8h4v4zm6-2V8h4v2zm6 3V8h4v5zm-6 5v-6h4v6zm-6 0v-4h4v4zm12 0v-3h4v3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsScreenoptions: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 9V3H3v6zm8 0V3h-6v6zm-8 8v-6H3v6zm8 0v-6h-6v6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsSearch: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.14 4.18a5.504 5.504 0 0 1 .72 6.89c.12.1.22.21.36.31c.2.16.47.36.81.59c.34.24.56.39.66.47c.42.31.73.57.94.78c.32.32.6.65.84 1c.25.35.44.69.59 1.04c.14.35.21.68.18 1q-.03.48-.36.81c-.33.33-.49.34-.81.36c-.31.02-.65-.04-.99-.19c-.35-.14-.7-.34-1.04-.59c-.35-.24-.68-.52-1-.84c-.21-.21-.47-.52-.77-.93c-.1-.13-.25-.35-.47-.66c-.22-.32-.4-.57-.56-.78c-.16-.2-.29-.35-.44-.5a5.5 5.5 0 0 1-6.44-.98c-2.14-2.15-2.14-5.64 0-7.78a5.5 5.5 0 0 1 7.78 0m-1.41 6.36a3.513 3.513 0 0 0 0-4.95a3.495 3.495 0 0 0-4.95 0a3.495 3.495 0 0 0 0 4.95a3.495 3.495 0 0 0 4.95 0\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsShare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14.5 12c1.66 0 3 1.34 3 3s-1.34 3-3 3s-3-1.34-3-3c0-.24.03-.46.09-.69l-4.38-2.3c-.55.61-1.33.99-2.21.99c-1.66 0-3-1.34-3-3s1.34-3 3-3c.88 0 1.66.39 2.21.99l4.38-2.3c-.06-.23-.09-.45-.09-.69c0-1.66 1.34-3 3-3s3 1.34 3 3s-1.34 3-3 3c-.88 0-1.66-.39-2.21-.99l-4.38 2.3a2.67 2.67 0 0 1 0 1.38l4.38 2.3c.55-.61 1.33-.99 2.21-.99\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsShareAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16.22 5.8c.47.69.29 1.62-.4 2.08c-.69.47-1.62.29-2.08-.4c-.16-.24-.35-.46-.55-.67a4.4 4.4 0 0 0-1.44-.96c-.27-.12-.55-.21-.84-.26c-.59-.13-1.23-.13-1.82-.01q-.435.09-.84.27c-.27.11-.53.25-.77.41s-.46.35-.66.55c-.21.21-.4.43-.56.67s-.3.5-.41.76c-.01.02-.01.03-.01.04c-.1.24-.17.48-.23.72H1V6h2.66c.04-.07.07-.13.12-.2c.27-.4.57-.77.91-1.11s.72-.65 1.11-.91c.4-.27.83-.51 1.28-.7s.93-.34 1.41-.43c.99-.21 2.03-.21 3.02 0c.48.09.96.24 1.41.43s.88.43 1.28.7c.39.26.77.57 1.11.91s.64.71.91 1.11M12.5 10a2.5 2.5 0 0 0-5 0a2.5 2.5 0 0 0 5 0m-8.72 4.2a1.497 1.497 0 1 1 2.48-1.68c.16.24.35.46.55.67a4.4 4.4 0 0 0 1.44.96c.27.12.55.2.84.26c.59.13 1.23.12 1.82 0c.29-.06.57-.14.84-.26c.27-.11.53-.25.77-.41s.46-.35.66-.55c.21-.21.4-.44.56-.67c.16-.25.3-.5.41-.76c.01-.02.01-.03.01-.04c.1-.24.17-.48.23-.72H19v3h-2.66c-.04.06-.07.13-.12.2c-.27.4-.57.77-.91 1.11s-.72.65-1.11.91c-.4.27-.83.51-1.28.7s-.93.33-1.41.43c-.99.21-2.03.21-3.02 0c-.48-.1-.96-.24-1.41-.43s-.88-.43-1.28-.7c-.39-.26-.77-.57-1.11-.91s-.64-.71-.91-1.11\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsShareAlt2: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m18 8l-5 4V9.01c-2.58.06-4.88.45-7 2.99c.29-3.57 2.66-5.66 7-5.94V3zM4 14h11v-2l2-1.6V16H2V5h9.43c-1.83.32-3.31 1-4.41 2H4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsShield: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 2s3 2 7 2c0 11-7 14-7 14S3 15 3 4c4 0 7-2 7-2m0 8h5s1-1 1-5c0 0-5-1-6-2zH5c1 4 5 7 5 7z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsShieldAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 2s3 2 7 2c0 11-7 14-7 14S3 15 3 4c4 0 7-2 7-2\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsShortcode: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 14H4V6h2V4H2v12h4zm1.1 3h2.1l3.7-14h-2.1zM14 4v2h2v8h-2v2h4V4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsSlides: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 14V6h10v8zm-3-1V7h2v6zm4-6v6h8V7zm10 0h2v6h-2zm-3 2V8H7v1zm0 3v-2H7v2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsSmartphone: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 2h8c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1m7 12V4H7v10zM8 5h4l-4 5z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsSmiley: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 5.2a2 2 0 0 1 2 2c0 .37-.11.71-.28 1C8.72 8.2 8 8 7 8s-1.72.2-1.72.2c-.17-.29-.28-.63-.28-1a2 2 0 0 1 2-2m6 0c1.11 0 2 .89 2 2c0 .37-.11.71-.28 1c0 0-.72-.2-1.72-.2s-1.72.2-1.72.2c-.17-.29-.28-.63-.28-1c0-1.11.89-2 2-2m-3 13.7a8.69 8.69 0 0 0 8.23-5.88l-1.32-.46C15.9 15.52 13.12 17.5 10 17.5s-5.9-1.98-6.91-4.94l-1.32.46A8.69 8.69 0 0 0 10 18.9\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsSort: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 7H1l5 7zm-2 7h10l-5-7z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsSos: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 10c0-4.42-3.58-8-8-8s-8 3.58-8 8s3.58 8 8 8s8-3.58 8-8M7.23 3.57L8.72 7.3c-.62.29-1.13.8-1.42 1.42L3.57 7.23a7.04 7.04 0 0 1 3.66-3.66m9.2 3.66L12.7 8.72c-.29-.62-.8-1.13-1.42-1.42l1.49-3.73c1.64.71 2.95 2.02 3.66 3.66M10 12c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2m-6.43.77l3.73-1.49c.29.62.8 1.13 1.42 1.42l-1.49 3.73a7.04 7.04 0 0 1-3.66-3.66m9.2 3.66l-1.49-3.73c.62-.29 1.13-.8 1.42-1.42l3.73 1.49a7.04 7.04 0 0 1-3.66 3.66\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsSpotify: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 2c-4.4 0-8 3.6-8 8s3.6 8 8 8s8-3.6 8-8s-3.6-8-8-8m3.7 11.5c-.1.2-.5.3-.7.2c-2.1-1.2-4.7-1.5-7-.8c-.3 0-.5-.1-.6-.4c0-.2.1-.5.4-.6c2.6-.8 5.4-.4 7.8.9c.1.2.2.5.1.7m1-2.1q-.15 0 0 0c-.2.3-.6.4-.9.2c-2.4-1.4-5.3-1.7-8-.9c-.3.1-.7-.1-.8-.4c-.1-.4.1-.7.4-.9c3-.9 6.3-.5 9 1.1c.3.2.4.6.3.9m0-2.3c-2.6-1.5-6.8-1.7-9.3-.9c-.4.1-.8-.1-.9-.5s.1-.8.5-1c2.8-.8 7.5-.7 10.5 1.1c.4.2.5.7.3 1c-.3.4-.7.5-1.1.3\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsStarEmpty: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 1L7 7l-6 .75l4.13 4.62L4 19l6-3l6 3l-1.12-6.63L19 7.75L13 7zm0 2.24l2.34 4.69l4.65.58l-3.18 3.56l.87 5.15L10 14.88l-4.68 2.34l.87-5.15l-3.18-3.56l4.65-.58z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsStarFilled: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m10 1l3 6l6 .75l-4.12 4.62L16 19l-6-3l-6 3l1.13-6.63L1 7.75L7 7z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsStarHalf: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 1L7 7l-6 .75l4.13 4.62L4 19l6-3l6 3l-1.12-6.63L19 7.75L13 7zm0 2.24l2.34 4.69l4.65.58l-3.18 3.56l.87 5.15L10 14.88z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsSticky: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 3.61V1.04l8.99-.01l-.01 2.58a2.74 2.74 0 0 0-2.16 2.67v.5c.01 1.31.93 2.4 2.17 2.66l-.01 2.58h-3.41l-.01 2.57c0 .6-.47 4.41-1.06 4.41c-.6 0-1.08-3.81-1.08-4.41v-2.56L5 12.02l.01-2.58a2.71 2.71 0 0 0 2.15-2.66v-.5c0-1.31-.92-2.41-2.16-2.67\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsStore: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 10c.41.29.96.43 1.5.43c.55 0 1.09-.14 1.5-.43c.62-.46 1-1.17 1-2c0 .83.37 1.54 1 2c.41.29.96.43 1.5.43c.55 0 1.09-.14 1.5-.43c.62-.46 1-1.17 1-2c0 .83.37 1.54 1 2c.41.29.96.43 1.51.43c.54 0 1.08-.14 1.49-.43c.62-.46 1-1.17 1-2c0 .83.37 1.54 1 2c.41.29.96.43 1.5.43c.55 0 1.09-.14 1.5-.43c.63-.46 1-1.17 1-2V7l-3-7H4L0 7v1c0 .83.37 1.54 1 2m2 8.99h5v-5h4v5h5v-7c-.37-.05-.72-.22-1-.43c-.63-.45-1-.73-1-1.56c0 .83-.38 1.11-1 1.56c-.41.3-.95.43-1.49.44c-.55 0-1.1-.14-1.51-.44c-.63-.45-1-.73-1-1.56c0 .83-.38 1.11-1 1.56c-.41.3-.95.43-1.5.44c-.54 0-1.09-.14-1.5-.44c-.63-.45-1-.73-1-1.57c0 .84-.38 1.12-1 1.57c-.29.21-.63.38-1 .44z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsSuperhero: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11.1 10L18 2L7 10h2l-7 8l11-8zm-4.3 1H3.9l2.5-1.8l7.5-5.5L10 2L3 5v3c0 2 .5 3.9 1.5 5.6zm6.4-2H16l-2.4 1.8L6.5 16c1 .9 2.2 1.6 3.5 2c4.2-1.5 7.1-5.5 7-10V5l-.2-.1z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsSuperheroAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15 5H5L2 8l8 8l8-8zm-3.3 6.9L10 11l-1.7.9l.3-1.9l-1.4-1.4l1.9-.3l.9-1.7l.9 1.8l1.9.3l-1.4 1.3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsTableColAfter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14.08 12.864V9.216h3.648V7.424H14.08V3.776h-1.728v3.648H8.64v1.792h3.712v3.648zM0 17.92V0h20.48v17.92zM6.4 1.28H1.28v3.84H6.4zm0 5.12H1.28v3.84H6.4zm0 5.12H1.28v3.84H6.4zM19.2 1.28H7.68v14.08H19.2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsTableColBefore: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.4 3.776v3.648H2.752v1.792H6.4v3.648h1.728V9.216h3.712V7.424H8.128V3.776zM0 17.92V0h20.48v17.92zM12.8 1.28H1.28v14.08H12.8zm6.4 0h-5.12v3.84h5.12zm0 5.12h-5.12v3.84h5.12zm0 5.12h-5.12v3.84h5.12z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsTableColDelete: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.4 9.98L7.68 8.7v-.256L6.4 7.164zm6.4-1.532l1.28-1.28V9.92L12.8 8.64zm7.68 9.472V0H0v17.92zm-1.28-2.56h-5.12v-1.024l-.256.256l-1.024-1.024v1.792H7.68v-1.792l-1.024 1.024l-.256-.256v1.024H1.28V1.28H6.4v2.368l.704-.704l.576.576V1.216h5.12V3.52l.96-.96l.32.32V1.216h5.12zm-5.76-2.112l-3.136-3.136l-3.264 3.264l-1.536-1.536l3.264-3.264L5.632 5.44l1.536-1.536l3.136 3.136l3.2-3.2l1.536 1.536l-3.2 3.2l3.136 3.136z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsTableRowAfter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.824 10.176h-2.88v-2.88H9.536v2.88h-2.88v1.344h2.88v2.88h1.408v-2.88h2.88zM0 17.92V0h20.48v17.92zM6.4 1.28H1.28v3.84H6.4zm6.4 0H7.68v3.84h5.12zm6.4 0h-5.12v3.84h5.12zm0 5.056H1.28v9.024H19.2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsTableRowBefore: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.656 6.464h2.88v2.88h1.408v-2.88h2.88V5.12h-2.88V2.24H9.536v2.88h-2.88zM0 17.92V0h20.48v17.92zm7.68-2.56h5.12v-3.84H7.68zm-6.4 0H6.4v-3.84H1.28zM19.2 1.28H1.28v9.024H19.2zm0 10.24h-5.12v3.84h5.12z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsTableRowDelete: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17.728 11.456L14.592 8.32l3.2-3.2l-1.536-1.536l-3.2 3.2L9.92 3.648L8.384 5.12l3.2 3.2l-3.264 3.264l1.536 1.536l3.264-3.264l3.136 3.136zM0 17.92V0h20.48v17.92zm19.2-6.4h-.448l-1.28-1.28H19.2V6.4h-1.792l1.28-1.28h.512V1.28H1.28v3.84h6.208l1.28 1.28H1.28v3.84h7.424l-1.28 1.28H1.28v3.84H19.2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsTablet: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 2h12c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1m11 14V4H5v12zM6 5h6l-6 5z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsTag: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 2h7v7L8 19l-7-7zm3 6c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsTagcloud: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 3v4H1V3zm8 0v4h-7V3zM7 8v3H1V8zm12 0v3H8V8zM9 12v2H1v-2zm10 0v2h-9v-2zM6 15v1H1v-1zm5 0v1H7v-1zm3 0v1h-2v-1zm5 0v1h-4v-1z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsTestimonial: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 3h12c.55 0 1.02.2 1.41.59S18 4.45 18 5v7c0 .55-.2 1.02-.59 1.41S16.55 14 16 14h-1l-5 5v-5H4c-.55 0-1.02-.2-1.41-.59S2 12.55 2 12V5c0-.55.2-1.02.59-1.41S3.45 3 4 3m11 2H4v1h11zm1 3H4v1h12zm-3 3H4v1h9z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsText: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 3v2H2V3zm-6 4v2H2V7zm6 0v2h-4V7zM8 11v2H2v-2zm10 0v2h-8v-2zm-4 4v2H2v-2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsTextPage: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 1v18h14V1zm9 13H6v-1h6zm2-3H6v-1h8zm0-3H6V7h8zm0-3H6V4h8z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsThumbsDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7.28 18c-.15.02-.26-.02-.41-.07c-.56-.19-.83-.79-.66-1.35c.17-.55 1-3.04 1-3.58c0-.53-.75-1-1.35-1h-3c-.6 0-1-.4-1-1s2-7 2-7c.17-.39.55-1 1-1H14v9h-2.14c-.41.41-3.3 4.71-3.58 5.27c-.21.41-.6.68-1 .73M18 12h-2V3h2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsThumbsUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.72 2c.15-.02.26.02.41.07c.56.19.83.79.66 1.35c-.17.55-1 3.04-1 3.58c0 .53.75 1 1.35 1h3c.6 0 1 .4 1 1s-2 7-2 7c-.17.39-.55 1-1 1H6V8h2.14c.41-.41 3.3-4.71 3.58-5.27c.21-.41.6-.68 1-.73M2 8h2v9H2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsTickets: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M20 5.38L18.99 8.2v-.01c-1.04-.37-2.19.18-2.57 1.22c-.37 1.04.17 2.19 1.22 2.56v.01l-1.01 2.82L1.57 9.42l.99-2.79c1.04.38 2.19-.17 2.56-1.21s-.17-2.18-1.21-2.55L4.93 0zm-5.45 3.37c.74-2.08-.34-4.37-2.42-5.12c-2.08-.74-4.37.35-5.11 2.42c-.74 2.08.34 4.38 2.42 5.12a4.01 4.01 0 0 0 5.11-2.42m-2.56-4.74c.89.32 1.57.94 1.97 1.71c-.01-.01-.02-.01-.04-.02c-.33-.12-.67.09-.78.4c-.1.28-.03.57.05.91c.04.27.09.62-.06 1.04c-.1.29-.33.58-.65 1l-.74 1.01l.08-4.08l.4.11c.19.04.26-.24.08-.29c0 0-.57-.15-.92-.28c-.34-.12-.88-.36-.88-.36c-.18-.08-.3.19-.12.27c0 0 .16.08.34.16l.01 1.63L9.2 9.18l.08-4.11c.2.06.4.11.4.11c.19.04.26-.23.07-.29c0 0-.56-.15-.91-.28c-.07-.02-.14-.05-.22-.08c.93-.7 2.19-.94 3.37-.52M7.4 6.19c.17-.49.44-.92.78-1.27l.04 5c-.94-.95-1.3-2.39-.82-3.73m4.04 4.75l2.1-2.63c.37-.41.57-.77.69-1.12c.05-.12.08-.24.11-.35c.09.57.04 1.18-.17 1.77a3.6 3.6 0 0 1-2.73 2.33m-.7-3.22l.02 3.22c0 .02 0 .04.01.06q-.6 0-1.2-.21q-.495-.18-.9-.48zm1.24 6.08l2.1.75c.24.84 1 1.45 1.91 1.45H16v3H0v-2.96a2 2 0 1 0 0-4V9h1.05l-.28.8l4.28 1.52A3.96 3.96 0 0 0 4 14c0 2.21 1.79 4 4 4s4-1.79 4-4c0-.07-.02-.13-.02-.2m-6.53-2.33l1.48.53c-.14.04-.15.27.03.28c0 0 .18.02.37.03l.56 1.54l-.78 2.36l-1.31-3.9c.21-.01.41-.03.41-.03c.19-.02.17-.31-.02-.3c0 0-.59.05-.96.05c-.07 0-.15 0-.23-.01c.13-.2.28-.38.45-.55M4.4 14c0-.52.12-1.02.32-1.46l1.71 4.7A3.62 3.62 0 0 1 4.4 14m4.19-1.41l1.72.62c.07.17.12.37.12.61c0 .31-.12.66-.28 1.16l-.35 1.2zM11.6 14c0 1.33-.72 2.49-1.79 3.11l1.1-3.18c.06-.17.1-.31.14-.46l.52.19c.02.11.03.22.03.34m-4.62 3.45l1.08-3.14l1.11 3.03c.01.02.01.04.02.05c-.37.13-.77.21-1.19.21c-.35 0-.69-.06-1.02-.15\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsTicketsAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M20 6.38L18.99 9.2v-.01c-.52-.19-1.03-.16-1.53.08s-.85.62-1.04 1.14s-.16 1.03.07 1.53c.24.5.62.84 1.15 1.03v.01l-1.01 2.82l-15.06-5.38l.99-2.79c.52.19 1.03.16 1.53-.08c.5-.23.84-.61 1.03-1.13s.16-1.03-.08-1.53a1.93 1.93 0 0 0-1.13-1.02L4.93 1zm-4.97 5.69l1.37-3.76c.12-.31.1-.65-.04-.95s-.39-.53-.7-.65L8.14 3.98c-.64-.23-1.37.12-1.6.74L5.17 8.48c-.24.65.1 1.37.74 1.6l7.52 2.74c.14.05.28.08.43.08c.52 0 1-.33 1.17-.83M7.97 4.45l7.51 2.73c.19.07.34.21.43.39c.08.18.09.38.02.57l-1.37 3.76c-.13.38-.58.59-.96.45L6.09 9.61a.75.75 0 0 1-.45-.96l1.37-3.76c.1-.29.39-.49.7-.49c.09 0 .17.02.26.05m6.82 12.14c.35.27.75.41 1.2.41H16v3H0v-2.96c.55 0 1.03-.2 1.41-.59c.39-.38.59-.86.59-1.41s-.2-1.02-.59-1.41s-.86-.59-1.41-.59V10h1.05l-.28.8l2.87 1.02c-.51.16-.89.62-.89 1.18v4c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25v-1.75l.83.3c.12.43.36.78.71 1.04M3.25 17v-4c0-.41.34-.75.75-.75h.83l7.92 2.83V17c0 .41-.34.75-.75.75H4c-.41 0-.75-.34-.75-.75\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsTide: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 12.8V17h14V9.9c-2.5.6-4.8 1.6-7 3V10c-2.2 1.3-4.5 2.3-7 2.8M17 3H3v7.1c2.5-.6 4.9-1.6 7-3.1v3c2.1-1.4 4.5-2.3 7-2.8z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsTranslation: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 7H9.49c-.63 0-1.25.3-1.59.7L7 5H4.13l-2.39 7h1.69l.74-2H7v4H2c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h7c1.1 0 2 .9 2 2zM6.51 9H4.49l1-2.93zM10 8h7c1.1 0 2 .9 2 2v7c0 1.1-.9 2-2 2h-7c-1.1 0-2-.9-2-2v-7c0-1.1.9-2 2-2m7.25 5v-1.08h-3.17V9.75h-1.16v2.17H9.75V13h1.28c.11.85.56 1.85 1.28 2.62c-.87.36-1.89.62-2.31.62c-.01.02.22.97.2 1.46c.84 0 2.21-.5 3.28-1.15c1.09.65 2.48 1.15 3.34 1.15c-.02-.49.2-1.44.2-1.46c-.43 0-1.49-.27-2.38-.63c.7-.77 1.14-1.77 1.25-2.61zm-3.81 1.93c-.5-.46-.85-1.13-1.01-1.93h2.09c-.17.8-.51 1.47-1 1.93l-.04.03s-.03-.02-.04-.03\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsTrash: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4h3c.6 0 1 .4 1 1v1H3V5c0-.6.5-1 1-1h3c.2-1.1 1.3-2 2.5-2s2.3.9 2.5 2M8 4h3c-.2-.6-.9-1-1.5-1S8.2 3.4 8 4M4 7h11l-.9 10.1c0 .5-.5.9-1 .9H5.9c-.5 0-.9-.4-1-.9z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsTwitch: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.7 2L2 4.6v11.8h3.2V18H7l1.8-1.6h2.9l5.7-5.2V2zM16 10.5l-2.5 2.3h-4l-2.2 2v-2H4.2V3.3H16zm-2.5-4.6h-1.4v3.9h1.4zm-4 0H8.1v3.9h1.4z\" clip-rule=\"evenodd\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsTwitter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18.94 4.46c-.49.73-1.11 1.38-1.83 1.9c.01.15.01.31.01.47c0 4.85-3.69 10.44-10.43 10.44c-2.07 0-4-.61-5.63-1.65c.29.03.58.05.88.05c1.72 0 3.3-.59 4.55-1.57a3.67 3.67 0 0 1-3.42-2.55c.22.04.45.07.69.07c.33 0 .66-.05.96-.13a3.68 3.68 0 0 1-2.94-3.6v-.04c.5.27 1.06.44 1.66.46a3.68 3.68 0 0 1-1.63-3.06c0-.67.18-1.3.5-1.84c1.81 2.22 4.51 3.68 7.56 3.83c-.06-.27-.1-.55-.1-.84a3.67 3.67 0 0 1 3.67-3.66c1.06 0 2.01.44 2.68 1.16c.83-.17 1.62-.47 2.33-.89c-.28.85-.86 1.57-1.62 2.02a7 7 0 0 0 2.11-.57\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsTwitterAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.9 13.8H8.5c-.2 0-.3-.1-.3-.4v-3h5.7c1.1 0 2.1-.9 2.1-2.1s-1-2.1-2.1-2.1H8.2V4.1C8.2 2.9 7.2 2 6 2c-1.1 0-2 .9-2 2.1v9.2C4 16 5.5 17.9 8.6 18H14c1.1 0 2.1-1 2.1-2.1c-.1-1.2-1.1-2.1-2.2-2.1\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsUndo: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 5H7V2L1 6l6 4V7h5c2.2 0 4 1.8 4 4s-1.8 4-4 4H7v2h5c3.3 0 6-2.7 6-6s-2.7-6-6-6\" class=\"st0\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsUniversalAccess: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 2.6c.83 0 1.5.67 1.5 1.5s-.67 1.51-1.5 1.51c-.82 0-1.5-.68-1.5-1.51s.68-1.5 1.5-1.5M3.4 7.36c0-.65 6.6-.76 6.6-.76s6.6.11 6.6.76s-4.47 1.4-4.47 1.4s1.69 8.14 1.06 8.38c-.62.24-3.19-5.19-3.19-5.19s-2.56 5.43-3.18 5.19c-.63-.24 1.06-8.38 1.06-8.38S3.4 8.01 3.4 7.36\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsUniversalAccessAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19 10a9 9 0 1 0-18.001.001A9 9 0 0 0 19 10m-9-7.4c.83 0 1.5.67 1.5 1.5s-.67 1.51-1.5 1.51c-.82 0-1.5-.68-1.5-1.51s.68-1.5 1.5-1.5M3.4 7.36c0-.65 6.6-.76 6.6-.76s6.6.11 6.6.76s-4.47 1.4-4.47 1.4s1.69 8.14 1.06 8.38c-.62.24-3.19-5.19-3.19-5.19s-2.56 5.43-3.18 5.19c-.63-.24 1.06-8.38 1.06-8.38S3.4 8.01 3.4 7.36\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsUnlock: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 9V6c0-1.1-.9-2-2-2s-2 .9-2 2H6c0-2.21 1.79-4 4-4s4 1.79 4 4v3h1c.55 0 1 .45 1 1v7c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1zm-1 7l-.36-2.15c.51-.24.86-.75.86-1.35c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5c0 .6.35 1.11.86 1.35L9 16z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsUpdate: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.2 3.28c3.53 0 6.43 2.61 6.92 6h2.08l-3.5 4l-3.5-4h2.32a4.44 4.44 0 0 0-4.32-3.45c-1.45 0-2.73.71-3.54 1.78L4.95 5.66a6.97 6.97 0 0 1 5.25-2.38m-.4 13.44c-3.52 0-6.43-2.61-6.92-6H.8l3.5-4c1.17 1.33 2.33 2.67 3.5 4H5.48a4.44 4.44 0 0 0 4.32 3.45c1.45 0 2.73-.71 3.54-1.78l1.71 1.95a6.95 6.95 0 0 1-5.25 2.38\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsUpdateAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.7 9c.4-2 2.2-3.5 4.3-3.5c1.5 0 2.7.7 3.5 1.8l1.7-2C14 3.9 12.1 3 10 3C6.5 3 3.6 5.6 3.1 9H1l3.5 4L8 9zm9.8-2L12 11h2.3c-.5 2-2.2 3.5-4.3 3.5c-1.5 0-2.7-.7-3.5-1.8l-1.7 1.9C6 16.1 7.9 17 10 17c3.5 0 6.4-2.6 6.9-6H19z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsUpdate2: Icon = {
  "body": "<path d=\"M10 3c2.09 0 3.97.92 5.25 2.38l-1.71 1.95A4.44 4.44 0 0 0 10 5.55C7.89 5.55 6.13 7.03 5.68 9H8l-3.5 4L1 9h2.08C3.57 5.61 6.47 3 10 3zm0 14.04c-2.1 0-3.97-.92-5.25-2.38l1.71-1.95A4.44 4.44 0 0 0 10 14.49c2.11 0 3.87-1.48 4.32-3.45H12l3.5-4 3.5 4h-2.08c-.49 3.39-3.4 6-6.92 6z\" fill=\"currentColor\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsUpload: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 14V8H5l5-6l5 6h-3v6zm-2 2v-6H4v8h12.01v-8H14v6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsVault: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 17V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1m-1 0H3V3h14zM4.75 4h10.5c.41 0 .75.34.75.75V6h-1v3h1v2h-1v3h1v1.25c0 .41-.34.75-.75.75H4.75c-.41 0-.75-.34-.75-.75V4.75c0-.41.34-.75.75-.75M13 10c0-2.21-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4s4-1.79 4-4M9 7l.77 1.15A2.02 2.02 0 0 1 11 10c0 1.1-.9 2-2 2s-2-.9-2-2c0-.83.51-1.54 1.23-1.85z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsVideoAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 5c0-.55-.45-1-1-1H2c-.55 0-1 .45-1 1c0 .57.49 1 1 1h5c.55 0 1-.45 1-1m6 5l4-4v10l-4-4zm-1 4V8c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h8c.55 0 1-.45 1-1\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsVideoAlt2: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 13V7c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2m1-2.5l6 4.5V5l-6 4.5z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsVideoAlt3: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19 15V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2M8 14V6l6 4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsVisibility: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18.3 9.5C15 4.9 8.5 3.8 3.9 7.2c-1.2.9-2.2 2.1-3 3.4c.2.4.5.8.8 1.2c3.3 4.6 9.6 5.6 14.2 2.4c.9-.7 1.7-1.4 2.4-2.4c.3-.4.5-.8.8-1.2c-.3-.4-.5-.8-.8-1.1m-8.2-2.3c.5-.5 1.3-.5 1.8 0s.5 1.3 0 1.8s-1.3.5-1.8 0s-.5-1.3 0-1.8m-.1 7.7c-3.1 0-6-1.6-7.7-4.2C3.5 9 5.1 7.8 7 7.2c-.7.8-1 1.7-1 2.7c0 2.2 1.7 4.1 4 4.1c2.2 0 4.1-1.7 4.1-4v-.1c0-1-.4-2-1.1-2.7c1.9.6 3.5 1.8 4.7 3.5c-1.7 2.6-4.6 4.2-7.7 4.2\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsWarning: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 2c4.42 0 8 3.58 8 8s-3.58 8-8 8s-8-3.58-8-8s3.58-8 8-8m1.13 9.38l.35-6.46H8.52l.35 6.46zm-.09 3.36c.24-.23.37-.55.37-.96c0-.42-.12-.74-.36-.97s-.59-.35-1.06-.35s-.82.12-1.07.35s-.37.55-.37.97c0 .41.13.73.38.96c.26.23.61.34 1.06.34s.8-.11 1.05-.34\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsWelcomeAddPage: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 7V4h-2V2h-3v1H3v15h11V9h1V7zm-1-2v1h-2v2h-1V6h-2V5h2V3h1v2z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsWelcomeComments: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 2h10c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2h-2l-5 5v-5H5c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2m8.5 8.5L11 8l2.5-2.5l-1-1L10 7L7.5 4.5l-1 1L9 8l-2.5 2.5l1 1L10 9l2.5 2.5z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsWelcomeLearnMore: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 10L2.54 7.02L3 18H1l.48-11.41L0 6l10-4l10 4zm0-5c-.55 0-1 .22-1 .5s.45.5 1 .5s1-.22 1-.5s-.45-.5-1-.5m0 6l5.57-2.23c.71.94 1.2 2.07 1.36 3.3c-.3-.04-.61-.07-.93-.07c-2.55 0-4.78 1.37-6 3.41A6.99 6.99 0 0 0 4 12c-.32 0-.63.03-.93.07c.16-1.23.65-2.36 1.36-3.3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsWelcomeViewSite: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 14V4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1m-8-8c2.3 0 4.4 1.14 6 3c-1.6 1.86-3.7 3-6 3s-4.4-1.14-6-3c1.6-1.86 3.7-3 6-3m2 3c0-1.1-.9-2-2-2s-2 .9-2 2s.9 2 2 2s2-.9 2-2m2 8h3v1H3v-1h3v-1h8z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsWelcomeWidgetsMenus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19 16V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v13c0 .55.45 1 1 1h15c.55 0 1-.45 1-1M4 4h13v4H4zm1 1v2h3V5zm4 0v2h3V5zm4 0v2h3V5zm-8.5 5c.28 0 .5.22.5.5s-.22.5-.5.5s-.5-.22-.5-.5s.22-.5.5-.5M6 10h4v1H6zm6 0h5v5h-5zm-7.5 2c.28 0 .5.22.5.5s-.22.5-.5.5s-.5-.22-.5-.5s.22-.5.5-.5M6 12h4v1H6zm7 0v2h3v-2zm-8.5 2c.28 0 .5.22.5.5s-.22.5-.5.5s-.5-.22-.5-.5s.22-.5.5-.5M6 14h4v1H6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsWelcomeWriteBlog: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m16.89 1.2l1.41 1.41c.39.39.39 1.02 0 1.41L14 8.33V18H3V3h10.67l1.8-1.8c.4-.39 1.03-.4 1.42 0m-5.66 8.48l5.37-5.36l-1.42-1.42l-5.36 5.37l-.71 2.12z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsWhatsapp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16.8 5.7C14.4 2 9.5.9 5.7 3.2C2 5.5.8 10.5 3.2 14.2l.2.3l-.8 3l3-.8l.3.2c1.3.7 2.7 1.1 4.1 1.1c1.5 0 3-.4 4.3-1.2c3.7-2.4 4.8-7.3 2.5-11.1m-2.1 7.7c-.4.6-.9 1-1.6 1.1c-.4 0-.9.2-2.9-.6c-1.7-.8-3.1-2.1-4.1-3.6c-.6-.7-.9-1.6-1-2.5c0-.8.3-1.5.8-2q.3-.3.6-.3H7c.2 0 .4 0 .5.4c.2.5.7 1.7.7 1.8c.1.1.1.3 0 .4c.1.2 0 .4-.1.5s-.2.3-.3.4c-.2.1-.3.3-.2.5c.4.6.9 1.2 1.4 1.7c.6.5 1.2.9 1.9 1.2c.2.1.4.1.5-.1s.6-.7.8-.9s.3-.2.5-.1l1.6.8c.2.1.4.2.5.3c.1.3.1.7-.1 1\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsWordpress: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M20 10c0-5.52-4.48-10-10-10S0 4.48 0 10s4.48 10 10 10s10-4.48 10-10M10 1.01c4.97 0 8.99 4.02 8.99 8.99s-4.02 8.99-8.99 8.99S1.01 14.97 1.01 10S5.03 1.01 10 1.01M8.01 14.82L4.96 6.61c.49-.03 1.05-.08 1.05-.08c.43-.05.38-1.01-.06-.99c0 0-1.29.1-2.13.1c-.15 0-.33 0-.52-.01c1.44-2.17 3.9-3.6 6.7-3.6c2.09 0 3.99.79 5.41 2.09c-.6-.08-1.45.35-1.45 1.42c0 .66.38 1.22.79 1.88c.31.54.5 1.22.5 2.21c0 1.34-1.27 4.48-1.27 4.48l-2.71-7.5c.48-.03.75-.16.75-.16c.43-.05.38-1.1-.05-1.08c0 0-1.3.11-2.14.11c-.78 0-2.11-.11-2.11-.11c-.43-.02-.48 1.06-.05 1.08l.84.08l1.12 3.04zm6.02 2.15L16.64 10s.67-1.69.39-3.81c.63 1.14.94 2.42.94 3.81c0 2.96-1.56 5.58-3.94 6.97M2.68 6.77L6.5 17.25c-2.67-1.3-4.47-4.08-4.47-7.25c0-1.16.2-2.23.65-3.23m7.45 4.53l2.29 6.25c-.75.27-1.57.42-2.42.42c-.72 0-1.41-.11-2.06-.3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsWordpressAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M20 10c0-5.51-4.49-10-10-10C4.48 0 0 4.49 0 10c0 5.52 4.48 10 10 10c5.51 0 10-4.48 10-10M7.78 15.37L4.37 6.22c.55-.02 1.17-.08 1.17-.08c.5-.06.44-1.13-.06-1.11c0 0-1.45.11-2.37.11c-.18 0-.37 0-.58-.01A8.87 8.87 0 0 1 10 1.11c2.33 0 4.45.87 6.05 2.34c-.68-.11-1.65.39-1.65 1.58c0 .74.45 1.36.9 2.1c.35.61.55 1.36.55 2.46c0 1.49-1.4 5-1.4 5l-3.03-8.37c.54-.02.82-.17.82-.17c.5-.05.44-1.25-.06-1.22c0 0-1.44.12-2.38.12c-.87 0-2.33-.12-2.33-.12c-.5-.03-.56 1.2-.06 1.22l.92.08l1.26 3.41zM17.41 10c.24-.64.74-1.87.43-4.25c.7 1.29 1.05 2.71 1.05 4.25c0 3.29-1.73 6.24-4.4 7.78c.97-2.59 1.94-5.2 2.92-7.78M6.1 18.09C3.12 16.65 1.11 13.53 1.11 10c0-1.3.23-2.48.72-3.59C3.25 10.3 4.67 14.2 6.1 18.09m4.03-6.63l2.58 6.98c-.86.29-1.76.45-2.71.45c-.79 0-1.57-.11-2.29-.33c.81-2.38 1.62-4.74 2.42-7.1\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsXing: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7.4 5.6c-.1-.3-.4-.4-.7-.4H4.4c-.2 0-.3.1-.4.3c0 .1 0 .2.1.2l1.6 2.7l-2.5 4.3c-.1.1-.1.2 0 .4c.1.1.2.2.3.2h2.3c.3 0 .5-.2.6-.4c0 0 2.4-4.2 2.5-4.4zm9.4-3.1c.1-.1.1-.2 0-.4c-.1-.1-.2-.1-.3-.1h-2.3c-.3 0-.5.2-.6.4c0 0-5 8.8-5.1 9.1l3.3 6c.1.3.4.4.6.4h2.3c.1 0 .2 0 .3-.1q.15-.15 0-.3l-3.2-5.9z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsYes: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m14.83 4.89l1.34.94l-5.81 8.38H9.02L5.78 9.67l1.34-1.25l2.57 2.4z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsYesAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 2c-4.42 0-8 3.58-8 8s3.58 8 8 8s8-3.58 8-8s-3.58-8-8-8m-.615 12.66h-1.34l-3.24-4.54l1.341-1.25l2.569 2.4l5.141-5.931l1.34.94z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsYoutube: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17.7 5.3c-.2-.7-.7-1.2-1.4-1.4c-2.1-.2-4.2-.4-6.3-.3q-3.15 0-6.3.3c-.6.2-1.2.8-1.4 1.4a37 37 0 0 0 0 9.4c.2.7.7 1.2 1.4 1.4c2.1.2 4.2.4 6.3.3q3.15 0 6.3-.3c.7-.2 1.2-.7 1.4-1.4a37 37 0 0 0 0-9.4M8 13V7l5.2 3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsMenuAlt21: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M20 5V2H0v3zm0 6V8H0v3zm0 6v-3H0v3z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const dashiconsPlusLight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 9v2h-6v6H9v-6H3V9h6V3h2v6z\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}